export default {
  "nav_signin": "Войти",
  "nav_account": "Аккаунт",
  "nav_signout": "Выйти",
  "hero_title": "Умные цифровые решения",
  "hero_title_line1": "Infinity Business — Умные",
  "hero_title_line2": "Цифровые решения",
  "hero_subtitle": "Познакомьтесь с RisTA, вашим цифровым партнёром",
  "hero_cta": "Поговорить с RisTA",
  "hero_cta2": "Посмотреть услуги",
  "b2b_title": "Бизнес-решения (B2B)",
  "p2p_title": "Персональные решения (P2P)",
  "b2b_desc": "Веб, мобильная разработка, ПО, хостинг, дизайн и реклама",
  "p2p_desc": "Крипто-образование, инвестиционные инструменты, организация, перевод, брендинг, домены",
  "services_title": "Наши услуги",
  "services_subtitle": "От корпоративных решений до персональных инвестиционных инструментов. RisTA проведёт вас.",
  "cta_title": "Готовы создать что-то удивительное?",
  "cta_subtitle": "Поговорите с RisTA для персонального расчёта стоимости за минуты.",
  "about": "О нас",
  "contact": "Контакты",
  "privacy": "Конфиденциальность",
  "blog": "Блог",
  "donate": "Пожертвовать",
  "booking": "Записаться",
  "login_title": "Добро пожаловать",
  "register_title": "Создать аккаунт",
  "login_subtitle": "Войдите в свой аккаунт Infinity Business",
  "register_subtitle": "Присоединяйтесь к Infinity Business",
  "auth0_btn": "Продолжить через Auth0",
  "or_email": "или продолжить по email",
  "email": "Электронная почта",
  "password": "Пароль",
  "full_name": "Полное имя",
  "signin_btn": "Войти",
  "register_btn": "Создать аккаунт",
  "no_account": "Нет аккаунта?",
  "have_account": "Уже есть аккаунт?",
  "create_one": "Создать",
  "sign_in": "Войти",
  "pricing_title": "Выберите план",
  "pricing_subtitle": "Все планы включают доступ к RisTA.",
  "pay_stripe": "Оплатить через Stripe",
  "pay_mypos": "Оплатить через myPOS",
  "pay_crypto": "Оплатить криптой",
  "free_plan": "Текущий бесплатный план",
  "most_popular": "Самый популярный",
  "dashboard_title": "Мой аккаунт",
  "profile": "Профиль",
  "security": "Безопасность (2FA)",
  "subscription": "Подписка",
  "upgrade": "Улучшить",
  "change_plan": "Сменить план",
  "twofa_title": "Двухфакторная аутентификация",
  "setup_2fa": "Настроить 2FA",
  "disable_2fa": "Отключить 2FA",
  "payment_success": "Оплата успешна!",
  "payment_cancel": "Оплата отменена",
  "footer_copyright": "© 2026 Liber Nostra d.o.o. Все права защищены.",
  "about_title": "Об Infinity Business",
  "contact_title": "Свяжитесь с нами",
  "privacy_title": "Политика конфиденциальности",
  "send_message": "Отправить сообщение",
  "trade_title": "Мы торгуем за вас",
  "trade_desc": "Профессиональные услуги крипто-трейдинга. Свяжитесь с нами.",
  "back_home": "На главную",
  "loading": "Загрузка...",
  "save": "Сохранить",
  "session_expired": "Ваша сессия истекла. Пожалуйста, войдите снова.",
  "nav_services": "Услуги",
  "nav_portal": "Портал",
  "nav_credits": "Кредиты",
  "hero_online": "Онлайн",
  "hero_digital_partner": "Цифровой партнёр",
  "business_solutions": "Бизнес-решения",
  "personal_solutions": "Персональные решения",
  "enterprise_desc": "Профессиональные цифровые услуги для роста вашего бизнеса.",
  "personal_desc": "Умные инвестиционные инструменты и образование для личного роста.",
  "services_hero_title": "Наши услуги",
  "services_hero_desc": "От простых сайтов до продвинутых ИИ-решений. Мы обеспечиваем цифровое совершенство.",
  "get_started": "Начать",
  "get_a_quote": "Получить цену",
  "free_seo_audit": "Бесплатный SEO-аудит",
  "ready_to_start": "Готовы начать?",
  "ready_to_build": "Готовы создать что-то удивительное?",
  "ready_to_build_sub": "Поговорите с RisTA для персонального расчёта.",
  "trusted_worldwide": "Доверие по всему миру",
  "chat_placeholder": "Введите сообщение...",
  "chat_suggested_1": "Мне нужен сайт",
  "chat_suggested_2": "Расскажите об услугах",
  "chat_suggested_3": "Хочу ИИ-услугу",
  "chat_suggested_4": "Получить оценку",
  "trust_platform": "Надёжная платформа",
  "trust_security": "Корпоративная безопасность",
  "trust_ai": "Умная технология",
  "trust_global": "Глобальный охват",
  "back_to_home": "На главную",
  "continue_google": "Продолжить с Google",
  "continue_facebook": "Продолжить с Facebook",
  "continue_github": "Продолжить с GitHub",
  "or_continue_email": "или продолжить с email",
  "two_factor_auth": "Двухфакторная аутентификация",
  "enter_2fa_code": "Введите код из приложения аутентификации",
  "verify_btn": "Подтвердить код",
  "verifying": "Проверка...",
  "use_different_account": "Использовать другой аккаунт",
  "session_expired_msg": "Ваша сессия истекла из-за неактивности.",
  "nav_home": "Главная",
  "nav_back": "Назад",
  "my_account": "Мой аккаунт",
  "sign_out": "Выйти",
  "client_portal": "Клиентский портал",
  "your_projects": "Ваши проекты",
  "your_invoices": "Ваши счета",
  "projects": "Проекты",
  "invoices_tab": "Счета",
  "milestones": "Вехи",
  "messages": "Сообщения",
  "no_projects": "Проектов пока нет.",
  "no_invoices": "Счетов пока нет.",
  "no_messages": "Сообщений пока нет.",
  "type_message": "Введите сообщение...",
  "back_to_projects": "К проектам",
  "budget_label": "Бюджет",
  "progress_label": "Прогресс",
  "service_label": "Услуга",
  "portal_locked_desc": "Портал доступен утверждённым клиентам.",
  "contact_to_start": "Свяжитесь с нами",
  "quick_web_dev": "Веб-разработка",
  "quick_mobile": "Мобильное приложение",
  "quick_crypto": "Крипто образование",
  "quick_get_quote": "Получить оценку",
  "quick_tell_more": "Расскажите подробнее",
  "quick_have_project": "У меня есть проект",
  "quick_submit": "Отправить запрос",
  "get_cost_estimate": "Оценка стоимости",
  "choose_plan": "Выберите план",
  "choose_plan_desc": "Масштабируйте бизнес с правильным планом.",
  "current_free_plan": "Текущий бесплатный план",
  "svc_ecommerce_label": "Интернет-магазин",
  "svc_ecommerce_desc": "Полноценные интернет-магазины с интеграцией оплаты",
  "svc_ecommerce_price": "От €799",
  "svc_seo_label": "SEO и цифровой маркетинг",
  "svc_seo_desc": "Поисковая оптимизация и стратегия роста",
  "svc_seo_price": "От €299/мес",
  "svc_hosting_label": "Управляемый хостинг",
  "svc_hosting_desc": "Безопасная, быстрая и надёжная хостинг-инфраструктура",
  "svc_hosting_price": "От €29/мес",
  "svc_advertising_label": "Цифровая реклама",
  "svc_advertising_desc": "PPC, реклама в соцсетях и перформанс-маркетинг",
  "svc_advertising_price": "От €499/мес",
  "svc_trading_label": "Торговая консультация",
  "svc_trading_desc": "Экспертные сессии по торговой стратегии",
  "svc_trading_price": "От €149/сессия",
  "svc_domains_label": "Управление доменами",
  "svc_domains_desc": "Регистрация доменов, управление DNS и переносы",
  "svc_domains_price": "От €19/год",
  "testimonials_title": "Что говорят наши клиенты",
  "testimonials_subtitle": "Нам доверяют компании по всей Европе",
  "stat_projects": "Проектов выполнено",
  "stat_satisfaction": "Удовлетворённость клиентов",
  "stat_languages": "Поддерживаемых языков",
  "all_rights_reserved": "Все права защищены.",
  "form_your_name": "Ваше имя",
  "form_your_email": "Ваш email",
  "form_describe_need": "Опишите ваши потребности...",
  "form_additional_feedback": "Дополнительный отзыв? (необязательно)",
  "form_email_followup": "Ваш email (необязательно)",
  "form_budget_range": "Диапазон бюджета",
  "form_timeline": "Сроки",
  "form_cancel": "Отмена",
  "form_select_services": "Выберите услуги (можно несколько):",
  "rating_title": "Оцените ваш опыт с RisTA",
  "rating_helpful": "Насколько полезен был разговор?",
  "rating_overall": "Общее впечатление от ассистента",
  "rating_recommend": "Порекомендуете ли вы RisTA?",
  "rating_yes": "Да",
  "rating_no": "Нет",
  "rating_submit": "Отправить оценку",
  "rating_skip": "Пропустить",
  "rating_thanks": "Спасибо за ваш отзыв!",
  "generating_estimate": "Создание оценки стоимости...",
  "profile_info": "Информация профиля",
  "profile_name": "Имя",
  "profile_email": "Email",
  "profile_role": "Роль",
  "profile_member_since": "Участник с",
  "profile_rerun_onboarding": "Повторить знакомство",
  "profile_language_pref": "Предпочитаемый язык",
  "profile_language_saved": "Языковые настройки сохранены!",
  "privacy_heading": "Политика конфиденциальности",
  "terms_heading": "Условия использования",
  "about_heading": "Об Infinity Business",
  "walkthrough_heading": "Руководства",
  "services_cta_title": "Готовы начать?",
  "services_talk_rista": "Поговорить с RisTA",
  "nav_tools": "Инструменты",
  "nav_marketplace": "Маркетплейс",
  "chat_digital_partner": "Цифровой партнёр",
  "chat_online": "Онлайн",
  "chat_help_text": "Я могу помочь с веб-разработкой, мобильными приложениями, дизайном, криптой и многим другим.",
  "chat_your_partner": "Ваш цифровой партнёр",
  "chat_assistant_subtitle": "Чат с вашим ИИ-ассистентом",
  "tab_password": "Пароль",
  "tab_rista_services": "Услуги RisTA",
  "tab_analytics": "Аналитика",
  "tab_projects": "Проекты",
  "tab_referral": "Реферальная программа",
  "marketplace_title": "Маркетплейс шаблонов",
  "marketplace_subtitle": "Премиум-шаблоны, которые вы можете настроить. Профессиональное качество.",
  "marketplace_search": "Поиск шаблонов...",
  "marketplace_purchase": "Купить",
  "marketplace_preview": "Предпросмотр",
  "marketplace_all": "Все",
  "marketplace_category_website": "Веб-сайт",
  "marketplace_category_brand": "Бренд",
  "marketplace_category_resume": "Резюме",
  "marketplace_downloads": "загрузок",
  "marketplace_features": "Функции",
  "case_studies_title": "Истории успеха клиентов",
  "case_studies_subtitle": "Реальные результаты от реальных компаний. Смотрите трансформацию.",
  "case_studies_before": "До",
  "case_studies_after": "После",
  "case_studies_cta_title": "Готовы развивать свой бизнес?",
  "case_studies_cta_desc": "Присоединяйтесь и получите похожие результаты с нашими ИИ-услугами.",
  "case_studies_cta_btn": "Начать",
  "profile_go_homepage": "На главную",
  "onboarding_welcome_title": "Добро пожаловать в Infinity Business",
  "onboarding_welcome_subtitle": "Ваш цифровой партнёр на базе ИИ",
  "onboarding_welcome_content": "Infinity Business предлагает комплексные B2B и P2P цифровые услуги. Наш ИИ-ассистент RisTA проведёт вас.",
  "onboarding_welcome_item1": "Оценка проектов с помощью интеллектуальных инструментов",
  "onboarding_welcome_item2": "Веб-, мобильные и дизайн-услуги",
  "onboarding_welcome_item3": "Крипто-образование и инвестиционные инструменты",
  "onboarding_welcome_item4": "Персонализированные консультации",
  "onboarding_next": "Далее",
  "onboarding_get_started": "Начать",
  "onboarding_back": "Назад",
  "onboarding_biz_title": "Выбор услуг",
  "onboarding_biz_subtitle": "Что лучше всего описывает ваши потребности?",
  "onboarding_biz_content": "Помогите нам рекомендовать правильные услуги:",
  "onboarding_biz_type_startup": "Стартап / Новый бизнес",
  "onboarding_biz_type_smb": "Малый-Средний бизнес",
  "onboarding_biz_type_enterprise": "Крупное предприятие / Корпорация",
  "onboarding_biz_type_freelancer": "Фрилансер / Индивидуал",
  "onboarding_biz_type_investor": "Инвестор / Крипто-энтузиаст",
  "change_password_title": "Изменить пароль",
  "referral_title": "Реферальная программа",
  "referral_generate": "Создать мой реферальный код",
  "referral_redeem_title": "Использовать код",
  "referral_redeem_btn": "Использовать",
  "referral_referrals": "Рефералы",
  "referral_rewards": "Награды",
  "referral_copy_link": "Копировать ссылку",
  "referral_copied": "Скопировано!",
  "project_tracker_title": "Отслеживание проектов",
  "analytics_total_services": "Всего услуг",
  "analytics_completed": "Завершённые",
  "analytics_pending": "В ожидании",
  "analytics_total_spent": "Всего потрачено",
  "analytics_credit_balance": "Баланс кредитов",
  "analytics_recent": "Последние услуги",
  "nav_try_free": "Попробовать бесплатно",
  "testimonial_1_text": "RisTA помогла нам создать всю нашу веб-презентацию всего за 2 недели.",
  "testimonial_2_text": "Бренд-кит и календарь для соцсетей сэкономили нам месяцы работы.",
  "testimonial_3_text": "Я регулярно использую конструктор резюме и инструменты анализа. Качество ИИ превосходное.",
  "services_cta_desc": "Поговорите с RisTA, нашим интеллектуальным цифровым помощником, чтобы получить персонализированное предложение.",
  "services_free_audit": "Бесплатный SEO аудит",
  "tools_title": "Бесплатные маркетинговые инструменты",
  "tools_subtitle": "Попробуйте наши бесплатные инструменты - без регистрации",
  "sp_basic_web_name": "Создание базового сайта",
  "sp_basic_web_desc": "Профессиональный сайт для вашего бизнеса с современным дизайном и полной мобильной совместимостью.",
  "sp_basic_web_feat": "Современный адаптивный дизайн|До 5 страниц|Интеграция контактной формы|Оптимизировано для мобильных|Базовая SEO настройка|Помощь с контентом",
  "sp_web_store_name": "Интернет-магазин / E-Commerce",
  "sp_web_store_desc": "Полнофункциональная e-commerce платформа с интегрированными платежами и маркетинговыми инструментами.",
  "sp_web_store_feat": "Полный интернет-магазин|Обработка платежей|Управление товарами|Отслеживание заказов|SEO оптимизация|Маркетинговая стратегия включена",
  "sp_custom_web_name": "Индивидуальное веб-приложение",
  "sp_custom_web_desc": "Веб-приложения, созданные по вашим точным бизнес-требованиям.",
  "sp_custom_web_feat": "Индивидуальный дизайн ПО|API интеграции|Архитектура БД|Масштабируемая инфраструктура|Админ-панели|Постоянная поддержка",
  "sp_mobile_app_name": "Мобильное приложение",
  "sp_mobile_app_desc": "Нативные и кросс-платформенные мобильные приложения для iOS и Android.",
  "sp_mobile_app_feat": "iOS и Android|Кросс-платформенная разработка|Push-уведомления|Публикация в магазинах|UI/UX дизайн|Интеграция бэкенда",
  "sp_seo_name": "SEO и цифровой маркетинг",
  "sp_seo_desc": "Повысьте видимость в интернете с помощью комплексных стратегий SEO и цифрового маркетинга.",
  "sp_seo_feat": "Полный SEO аудит|Оптимизация ключевых слов|Контент-стратегия|Управление Google Ads|Маркетинг в соцсетях|Ежемесячные отчёты",
  "sp_graphic_name": "Графический дизайн и брендинг",
  "sp_graphic_desc": "Полные решения по брендингу и графическому дизайну для идентичности вашего бизнеса.",
  "sp_graphic_feat": "Дизайн логотипа|Фирменный стиль|Маркетинговые материалы|Графика для соцсетей|Печатный дизайн|Руководство по стилю",
  "sp_crypto_edu_name": "Программа крипто-образования",
  "sp_crypto_edu_desc": "Изучите торговлю криптовалютами и технологию блокчейн у экспертов отрасли.",
  "sp_crypto_edu_feat": "Основы блокчейна|Торговые стратегии|Безопасность кошелька|Введение в DeFi|Анализ рынка|Персональное менторство",
  "sp_invest_name": "Умные инвестиционные инструменты",
  "sp_invest_desc": "Профессиональные инструменты отслеживания и анализа инвестиций на базе ИИ.",
  "sp_invest_feat": "Трекер портфеля|Дашборд рынка|ИИ-аналитика|Оценка рисков|Оповещения в реальном времени|Мульти-биржевая поддержка",
  "sp_ad_name": "Рекламные услуги",
  "sp_ad_desc": "Охватите миллионы через нашу обширную сеть порталов в нескольких регионах.",
  "sp_ad_feat": "Сеть 20+ порталов|10М+ охват|Таргетированные кампании|Отслеживание эффективности|Мульти-платформенная реклама|Оптимизация ROI",
  "contact_heading": "Свяжитесь с нами",
  "contact_subtitle_text": "Есть вопрос или хотите обсудить проект? Мы будем рады вас выслушать.",
  "contact_name_label": "Имя",
  "contact_email_label": "Email",
  "contact_subject_label": "Тема",
  "contact_message_label": "Сообщение",
  "contact_name_ph": "Ваше имя",
  "contact_email_ph": "вы@пример.com",
  "contact_subject_ph": "О чём речь?",
  "contact_message_ph": "Расскажите о вашем проекте или вопросе...",
  "contact_send_btn": "Отправить сообщение",
  "contact_sending": "Отправка...",
  "contact_sent_title": "Сообщение отправлено!",
  "contact_sent_msg": "Спасибо за обращение. Мы ответим в течение 24 часов.",
  "contact_send_another": "Отправить ещё сообщение",
  "contact_info_email": "Email",
  "contact_info_location": "Расположение",
  "contact_info_eu": "Европейский Союз",
  "contact_info_response": "Время ответа",
  "contact_info_response_time": "В течение 24 часов",
  "contact_info_hours": "Пн - Пт, 9:00 - 18:00 CET",
  "tf_seo_name": "Бесплатный SEO аудит",
  "tf_seo_desc": "Получите комплексный SEO анализ любого сайта - без регистрации.",
  "tf_color_name": "Генератор цветовой палитры",
  "tf_color_desc": "Создавайте красивые, гармоничные цветовые палитры для вашего бренда.",
  "tf_headline_name": "Анализатор заголовков",
  "tf_headline_desc": "Оцените заголовки на кликабельность и эмоциональное воздействие.",
  "tf_chat_name": "Чат с RisTA",
  "tf_chat_desc": "Получите мгновенные оценки проектов и изучите услуги на 11 языках.",
  "tf_free_label": "Бесплатно",
  "tools_seo_title": "Быстрая SEO проверка",
  "tools_seo_desc": "Мгновенная SEO оценка для любого сайта",
  "tools_seo_ph": "Введите URL сайта (напр. пример.com)",
  "tools_analyze": "Анализировать",
  "tools_color_title": "Генератор цветовой палитры",
  "tools_color_desc": "Создавайте комплементарные цветовые палитры",
  "tools_headline_title": "Анализатор заголовков",
  "tools_headline_desc": "Анализируйте эффективность заголовков",
  "tools_headline_ph": "Введите ваш заголовок...",
  "tools_headline_btn": "Анализировать заголовок",
  "tools_issues": "Найденные проблемы",
  "tools_suggestions": "Предложения",
  "tools_score": "Оценка",
  "docs_heading": "Функции платформы",
  "docs_subtitle": "Всё, что Infinity Business предлагает для вашего цифрового пути.",
  "docs_no_data": "Документация недоступна.",
  "tester_heading": "Стать тестером",
  "tester_subtitle": "Помогите нам улучшить платформу и получите бесплатный доступ к услугам.",
  "tester_req_title": "Что требуется",
  "tester_benefit_title": "Что вы получите",
  "tester_apply_title": "Подать заявку",
  "tester_submit_app": "Отправить заявку",
  "tester_applied_title": "Заявка отправлена",
  "tester_applied_msg": "Наш администратор рассмотрит вашу заявку, и вы получите уведомление.",
  "tester_need_account": "Для подачи заявки нужен аккаунт.",
  "tester_dash_title": "Панель тестера",
  "tester_weekly_logins": "Еженедельные входы",
  "tester_weekly_reports": "Еженедельные отчёты",
  "tester_target_met": "Цель достигнута!",
  "tester_total_reports": "Всего отправлено отчётов",
  "tester_on_track": "На пути",
  "tester_at_risk": "Под угрозой",
  "tester_report_heading": "Отправить отчёт об ошибке / отзыв",
  "tester_submit_report": "Отправить отчёт",
  "seo_page_title": "Бесплатный SEO аудит",
  "seo_page_btn": "Запустить аудит",
  "seo_page_running": "Анализ...",
  "referral_reward_title": "Как работают награды",
  "referral_reward_desc": "Зарабатывайте 10% от каждой покупки приглашённых вами пользователей, автоматически зачисляемые как бесплатные кредиты.",
  "referral_reward_1": "Поделитесь уникальной реферальной ссылкой с друзьями",
  "referral_reward_2": "Когда они совершают покупку, вы получаете 10% как бесплатные кредиты",
  "referral_reward_3": "Кредиты автоматически добавляются к вашему балансу",
  "referral_earned_label": "Заработанные кредиты",
  "profile_picture": "Фото профиля",
  "profile_bio": "Биография",
  "profile_website": "Сайт",
  "profile_interests": "Интересы",
  "profile_upload_photo": "Загрузить фото",
  "profile_save": "Сохранить профиль",
  "admin_notes": "Заметки администратора",
  "admin_notes_add": "Добавить заметку",
  "sub_most_popular": "Самый популярный",
  "sub_free": "Бесплатно",
  "sub_one_time": "единоразово",
  "sub_team_members": "Члены команды",
  "sub_members_info": "Пригласите членов команды для совместного использования плана. Каждый участник получает собственный логин и доступ к услугам.",
  "sub_show_less": "Показать меньше",
  "sub_more_features": "ещё функций",
  "sub_pay_with": "Оплатить через",
  "sub_preferred": "предпочтительный",
  "sub_live_crypto": "Цены криптовалют в реальном времени (EUR и USD)",
  "sp_logo_name": "Дизайн логотипа",
  "sp_logo_desc": "Профессиональный дизайн логотипа, передающий суть вашего бренда.",
  "sp_logo_feat": "3 уникальных концепта|Безлимитные правки|Векторные файлы|Цветной + Ч/Б|Гайдлайн бренда|Набор для соцсетей",
  "sp_brand_name": "Полный фирменный стиль",
  "sp_brand_desc": "Полный пакет фирменного стиля с логотипом, палитрой и руководством.",
  "sp_brand_feat": "Логотип|Цветовая палитра|Типографика|Визитка|Бланк|PDF руководство|Шаблоны для соцсетей",
  "sp_poster_name": "Дизайн плаката",
  "sp_poster_desc": "Привлекательный дизайн плакатов для мероприятий и рекламных кампаний.",
  "sp_poster_feat": "Иллюстрация|Файлы для печати|Несколько размеров|2 раунда правок|Высокое разрешение|Цифровой + печать",
  "sp_flyer_name": "Дизайн флаера",
  "sp_flyer_desc": "Профессиональный дизайн флаеров для маркетинга и мероприятий.",
  "sp_flyer_feat": "Лицевая и обратная сторона|PDF для печати|Цифровая версия|QR-код|2 правки|Несколько форматов",
  "sp_menu_name": "Дизайн меню",
  "sp_menu_desc": "Красивый дизайн меню для ресторанов и кафе.",
  "sp_menu_feat": "Индивидуальный макет|Фото интеграция|QR-версия|Файлы для печати|Сезонное обновление|Несколько страниц",
  "currency_label": "Валюта",
  "currency_eur": "EUR",
  "currency_usd": "USD",
  "currency_cny": "CNY",
  "about_intro": "Мы технологическая компания, специализирующаяся на интеллектуальных цифровых решениях. Основанная в 2026 году, Infinity Business сочетает инновации ИИ с проверенным опытом.",
  "about_values": "Наши Ценности",
  "about_what_we_do": "Что Мы Делаем",
  "about_meet_rista": "Познакомьтесь с RisTA",
  "about_rista_desc": "RisTA — наш интеллектуальный ИИ-ассистент. Помогает определить требования, предоставляет мгновенные консультации и связывает вас с нашей командой. Доступен 24/7, многоязычный.",
  "about_talk_rista": "Поговорить с RisTA",
  "about_val_trust": "Доверие и Безопасность",
  "about_val_trust_desc": "Мы применяем высочайшие стандарты защиты данных.",
  "about_val_innovation": "Инновации",
  "about_val_innovation_desc": "Передовые технологии ИИ обеспечивают наши решения.",
  "about_val_partnership": "Партнёрство",
  "about_val_partnership_desc": "Мы работаем рядом с вами как настоящий партнёр.",
  "about_val_global": "Глобальный Охват",
  "about_val_global_desc": "Наши решения разработаны для международных рынков.",
  "about_svc_web": "Веб-разработка",
  "about_svc_web_desc": "Полноценные веб-приложения, платформы электронной коммерции и CMS.",
  "about_svc_mobile": "Мобильные Приложения",
  "about_svc_mobile_desc": "Нативные и кросс-платформенные приложения для iOS и Android.",
  "about_svc_software": "Индивидуальное ПО",
  "about_svc_software_desc": "Программные решения на заказ для автоматизации бизнес-процессов.",
  "about_svc_invest": "Умные Инвестиции",
  "about_svc_invest_desc": "Крипто и DeFi инструменты на базе ИИ с профессиональными торговыми услугами.",
  "micro_tools_title": "ИИ Микро-инструменты",
  "micro_tools_subtitle": "Мгновенные ИИ-инсайты для генерации лидов и стратегического планирования.",
  "micro_tools_all": "Все",
  "micro_tools_try": "Попробовать",
  "micro_tools_generate_free": "Создать (Бесплатно)",
  "micro_tools_generate_paid": "Создать",
  "micro_tools_close": "Закрыть",
  "micro_tools_interested": "Заинтересованы?",
  "tools_view_service": "Посмотреть сервис",
  "tools_talk_rista": "Поговорить с RisTA",
  "competitor_title": "ИИ-анализ конкурентов",
  "competitor_desc": "Введите URL конкурента для ИИ-анализа с сравнением SEO и оценкой дизайна.",
  "competitor_url_ph": "Введите URL конкурента",
  "competitor_analyze": "Анализировать конкурента",
  "competitor_score": "Общая оценка",
  "competitor_seo": "Анализ SEO",
  "competitor_design": "Анализ дизайна",
  "competitor_content": "Анализ контента",
  "competitor_strengths": "Сильные стороны",
  "competitor_weaknesses": "Слабые стороны",
  "competitor_opportunities": "Возможности",
  "competitor_recommendations": "Рекомендации",
  "accessibility_title": "Проверка доступности",
  "accessibility_desc": "Проверка стандартов доступности",
  "cat_lead_gen": "Генерация лидов",
  "cat_discovery": "Обнаружение отчётов",
  "cat_email": "Email и workflow",
  "cat_planning": "Планирование и стратегия",
  "cat_content": "Контент и позиционирование",
  "sp_tools_title": "Умные микро-сервисы",
  "sp_tools_desc": "Мгновенные интеллектуальные услуги для контента, брендинга, анализа и документов.",
  "sp_free_title": "Бесплатные инструменты",
  "sp_free_desc": "Попробуйте нашу платформу с этими бесплатными инструментами.",
  "a11y_checker": "Проверка доступности",
  "a11y_rescan": "Повторная проверка",
  "a11y_scanning": "Выполнение аудита WCAG...",
  "a11y_compliant": "Соответствует",
  "a11y_passed": "пройдено",
  "a11y_violations": "нарушения",
  "a11y_incomplete": "требует проверки",
  "a11y_issues_found": "Найдены проблемы",
  "a11y_no_issues": "Проблем доступности не найдено!",
  "a11y_disclaimer": "Автоматические проверки покрывают ~30% проблем. Рекомендуется ручное тестирование с экранными чтецами.",
  "a11y_error": "Аудит не удался. Попробуйте снова.",
  "admin_ratings": "Рейтинги и отзывы",
  "admin_timeline": "Временная шкала проекта",
  "admin_add_milestone": "Добавить веху",
  "admin_milestone_title": "Название вехи",
  "admin_milestone_desc": "Описание (необязательно)",
  "admin_no_milestones": "Вех пока нет. Добавьте первую!",
  "admin_email_templates_desc": "Настройте шаблоны email с помощью визуального редактора блоков.",
  "admin_preloader": "Настройка прелоадера",
  "admin_image_gen": "Генерация изображений",
  "admin_health_score": "Оценка здоровья",
  "nav_health_score": "Оценка здоровья",
  "admin_new": "новое",
  "admin_score": "Оценка",
  "admin_avg_rating": "Средний рейтинг",
  "admin_avg_exp": "Средний опыт",
  "admin_reviews": "отзывов",
  "admin_out_of": "Из",
  "admin_total": "Всего",
  "admin_unread": "Непрочитанные",
  "admin_active": "Активные",
  "admin_pending": "Ожидающие",
  "admin_save": "Сохранить",
  "admin_cancel": "Отмена",
  "admin_delete": "Удалить",
  "admin_edit": "Редактировать",
  "admin_status": "Статус",
  "admin_actions": "Действия",
  "admin_created": "Создано",
  "admin_updated": "Обновлено",
  "admin_view_all": "Показать все",
  "admin_no_data": "Нет доступных данных",
  "status_planned": "Запланировано",
  "status_in_progress": "В процессе",
  "status_completed": "Завершено",
  "status_blocked": "Заблокировано",
  "priority_low": "Низкий",
  "priority_medium": "Средний",
  "priority_high": "Высокий",
  "priority_critical": "Критический",
  "analytics_subscription": "Подписка",
  "developer_title": "API для разработчиков",
  "developer_subtitle": "Интегрируйте наши интеллектуальные сервисы в свои приложения",
  "estimate_accept": "Принять и отправить",
  "estimate_revise": "Пересмотреть",
  "estimate_title": "Оценка стоимости проекта",
  "estimate_service": "Услуга",
  "estimate_complexity": "Сложность",
  "estimate_base_price": "Базовая цена",
  "estimate_cost": "Оценённая стоимость",
  "estimate_features": "Ключевые особенности",
  "hosting_title": "Пакеты хостинга",
  "hosting_subtitle": "Надёжный и быстрый хостинг для вашего бизнеса",
  "sp_health_score": "Оценка здоровья сайта",
  "sp_health_score_desc": "Комплексный анализ сайта: SEO, производительность, безопасность и доступность.",
  "sp_health_score_name": "Оценка здоровья сайта",
  "sp_health_score_feat": "SEO-анализ|Проверка производительности|Сканирование безопасности|Аудит доступности|Подробный отчёт|Советы по улучшению",
  "sp_hosting_name": "Управляемый веб-хостинг",
  "sp_hosting_desc": "Безопасная, быстрая и надёжная хостинг-инфраструктура для ваших сайтов и приложений.",
  "sp_hosting_feat": "99,9% доступность|SSL-сертификаты|Ежедневные бэкапы|Интеграция CDN|Мониторинг 24/7|Автомасштабирование",
  "sp_biz_plan_name": "Умный бизнес-план",
  "sp_biz_plan_desc": "Создайте комплексный бизнес-план с финансами, анализом рынка и стратегией роста.",
  "sp_biz_plan_feat": "Резюме|Анализ рынка|Финансовые прогнозы|Обзор конкурентов|Стратегия роста|Формат для инвесторов",
  "sp_seo_report_name": "Отчёт аудита сайта",
  "sp_seo_report_desc": "Автоматический анализ сайта с практическими SEO-рекомендациями и инсайтами по производительности.",
  "sp_seo_report_feat": "100+ контрольных точек|Метрики производительности|SEO-рекомендации|Мобильный анализ|Обзор безопасности|План действий",
  "sp_email_campaign_name": "Настройка email-маркетинга",
  "sp_email_campaign_desc": "Профессиональная настройка email-кампании с текстами, последовательностями и таргетингом.",
  "sp_email_campaign_feat": "Написание писем|Настройка последовательностей|Таргетинг аудитории|A/B-тесты|Настройка аналитики|Дизайн шаблонов",
  "sp_competitor_name": "Анализ конкурентов",
  "sp_competitor_desc": "Глубокая конкурентная разведка с SEO-сравнением, обзором дизайна и анализом пробелов.",
  "sp_competitor_feat": "SEO-сравнение|Обзор дизайна|Пробелы контента|Позиционирование|SWOT-анализ|Стратегические рекомендации",
  "sp_legal_docs_name": "Генератор юридических документов",
  "sp_legal_docs_desc": "Профессиональные юридические шаблоны: NDA, контракты и Условия использования.",
  "sp_legal_docs_feat": "Шаблоны NDA|Контракты на услуги|Условия использования|Политика конфиденциальности|Соответствие GDPR|Индивидуальные пункты",
  "sp_resume_name": "Умный конструктор резюме",
  "sp_resume_desc": "Создайте ATS-оптимизированные резюме для вашей целевой должности и отрасли.",
  "sp_resume_feat": "ATS-оптимизация|Отраслевые шаблоны|Подбор ключевых слов|Сопроводительное письмо|Оптимизация LinkedIn|Экспорт PDF",
  "sp_brand_kit_name": "Умный логотип и фирменный стиль",
  "sp_brand_kit_desc": "Полный пакет фирменного стиля с концепциями логотипа, цветовой палитрой и материалами для соцсетей.",
  "sp_brand_kit_feat": "Концепции логотипа|Цветовая палитра|Типографика|Материалы для соцсетей|Руководство по бренду|Набор иконок",
  "sp_social_cal_name": "Календарь социальных сетей",
  "sp_social_cal_desc": "30 дней интеллектуально сгенерированных публикаций со стратегией вовлечения.",
  "sp_social_cal_feat": "Календарь 30 дней|Тексты публикаций|Стратегия хэштегов|Советы по вовлечению|Лучшее время публикации|Оптимизация платформы",
  "sp_translation_name": "Умный перевод",
  "sp_translation_desc": "Профессиональный перевод документов на 50+ языков с культурной адаптацией.",
  "sp_translation_feat": "50+ языков|Культурная адаптация|Технические термины|Быстрая доставка|Корректура|Сохранение формата",
  "sp_video_script_name": "Умный сценарист видео",
  "sp_video_script_desc": "Увлекательные видеосценарии для YouTube, TikTok и рекламы, оптимизированные для максимального вовлечения.",
  "sp_video_script_feat": "Сценарии YouTube|Контент TikTok|Рекламный текст|Оптимизация хука|Размещение CTA|Советы по вовлечению",
  "sp_free_seo_name": "Бесплатный SEO-аудит",
  "sp_free_seo_desc": "Проведите бесплатный SEO-аудит любого сайта для поиска возможностей оптимизации.",
  "sp_free_seo_feat": "Мгновенные результаты|100+ проверок|Оценка производительности|Мобильная проверка|Сканирование безопасности|Бесплатный отчёт",
  "sp_free_tools_name": "Бесплатные цифровые инструменты",
  "sp_free_tools_desc": "Получите доступ к коллекции бесплатных инструментов: палитры цветов, анализатор заголовков и другое.",
  "sp_free_tools_feat": "Генератор палитр|Анализатор заголовков|Генератор паролей|Генератор QR-кодов|Конвертер единиц|Без регистрации",
  "admin_chat_analytics": "Аналитика чатов",
  "admin_ab_testing": "A/B-тестирование",
  "admin_ui_toggles": "Переключатели UI",
  "admin_audit_trail": "Журнал аудита",
  "admin_adv_reports": "Расширенные отчёты",
  "admin_rate_limiting": "Ограничение скорости",
  "admin_email_builder": "Конструктор email",
  "admin_rbac": "Контроль доступа",
  "admin_social_auto": "Автоматизация соцсетей",
  "admin_health_monitor": "Мониторинг здоровья",
  "profile_country": "Страна",
  "profile_country_ph": "напр. Россия, Германия, США",
  "health_title": "Оценка здоровья сайта",
  "health_desc": "Комплексный анализ SEO, производительности, безопасности и доступности вашего сайта на одной панели.",
  "health_premium_badge": "Премиум функция",
  "health_url_ph": "Введите URL сайта (напр. example.com)",
  "health_scan_btn": "Сканировать",
  "health_scanning": "Сканирование...",
  "health_scan_error": "Не удалось отсканировать сайт. Проверьте URL.",
  "health_overall": "Общая оценка здоровья",
  "health_response": "Ответ",
  "health_size": "Размер",
  "health_seo": "SEO",
  "health_perf": "Производительность",
  "health_security": "Безопасность",
  "health_a11y": "Доступность",
  "health_history": "История сканирований",
  "health_login_required": "Войдите для использования оценки здоровья",
  "health_login_desc": "Создайте бесплатную учётную запись для сканирования сайта и отслеживания улучшений.",
  "health_upsell_title": "Хотите периодический мониторинг?",
  "health_upsell_desc": "Перейдите на Premium для автоматических еженедельных сканирований, email-оповещений и отслеживания трендов.",
  "health_upgrade_btn": "Перейти на Premium",
  "seo_cta_title": "Нужна помощь в исправлении этих проблем?",
  "seo_cta_desc": "Наш интеллектуальный SEO-аудит охватывает 100+ контрольных точек. Получите профессиональную помощь.",
  "walkthrough_gmail": "Умный помощник Gmail",
  "walkthrough_gmail_desc": "Узнайте, как RisTA организует вашу почту",
  "walkthrough_calendar": "Персональный консультант",
  "walkthrough_calendar_desc": "Календарь, задачи и email через чат",
  "walkthrough_ai": "Услуги интеллектуальной системы",
  "walkthrough_ai_desc": "Резюме, бизнес-планы, фирменные стили и другое",
  "submit_service_request": "Отправить заявку на услугу",
  "profile_admin_dashboard": "Открыть панель администратора",
  "profile_appearance": "Внешний вид и доступность",
  "profile_theme": "Тема",
  "profile_text_size": "Размер текста",
  "profile_text_size_hint": "Настройте размер текста для удобного чтения.",
  "try_free_title": "Бесплатные инструменты и пробные услуги",
  "try_free_subtitle": "Без кредитной карты. Начните использовать наши инструменты прямо сейчас.",
  "try_free_section": "Полностью бесплатно — без регистрации",
  "try_free_trial_section": "Услуги интеллектуальной системы — Попробуйте с кредитами",
  "try_free_trial_desc": "Зарегистрируйтесь для получения кредитов и доступа к умным сервисам.",
  "try_free_cta": "Готовы начать?",
  "try_free_cta_desc": "Создайте бесплатный аккаунт для получения первых кредитов и доступа ко всем умным сервисам.",
  "try_free_cta_btn": "Зарегистрируйтесь бесплатно",
  "review_title": "Что говорят наши клиенты",
  "review_subtitle": "Реальные отзывы от компаний, которым мы помогли",
  "testimonial_1_role": "CEO, TechStart d.o.o.",
  "testimonial_2_role": "Директор по маркетингу, BioFresh",
  "testimonial_3_role": "Фрилансер-разработчик",
  "admin_overview": "Обзор",
  "admin_my_account": "Мой аккаунт",
  "admin_health": "Мониторинг здоровья",
  "admin_analytics": "Аналитика",
  "admin_integrations": "Интеграции",
  "admin_requests": "Заявки на услуги",
  "admin_high_value": "Высокоценные лиды",
  "admin_followups": "Последующие email",
  "admin_users": "Управление пользователями",
  "admin_crypto_payments": "Криптоплатежи",
  "admin_bug_reports": "Отчёты об ошибках",
  "admin_pricing": "Динамическое ценообразование",
  "admin_defi": "DeFi элементы",
  "admin_chat_sessions": "Чат-сессии",
  "admin_language_requests": "Языковые запросы",
  "admin_notifications": "Уведомления",
  "admin_sendgrid": "Email (SendGrid)",
  "admin_ai_config": "Настройка модели",
  "admin_live_analytics": "Аналитика в реальном времени",
  "admin_system_config": "Системная конфигурация",
  "admin_backup": "Резервное копирование и восстановление",
  "admin_referrals": "Реферальная программа",
  "admin_invoices": "Выставление счетов",
  "admin_billing": "Периодическая оплата",
  "admin_blog": "Менеджер блога",
  "admin_logo": "Логотип и фавикон",
  "admin_promo": "Промокоды",
  "admin_currency": "Мультивалюта",
  "admin_domain": "Менеджер доменов",
  "admin_cdn": "Менеджер CDN",
  "admin_social": "Социальные сети",
  "admin_avatar_selector": "Выбор аватара",
  "admin_avatar_builder": "Конструктор аватара",
  "admin_client_portal": "Клиентский портал",
  "admin_abandoned_carts": "Брошенные корзины",
  "rista_login_required": "Требуется вход",
  "rista_login_desc": "Войдите или создайте аккаунт, чтобы общаться с RisTA и получать персонализированные бизнес-рекомендации.",
  "rista_login_btn": "Войти",
  "rista_signup_btn": "Регистрация",
  "admin_high_leads": "Приоритетные лиды",
  "admin_surveys": "Опросы удовлетворённости",
  "admin_rista": "Услуги RisTA",
  "admin_docs": "Документация",
  "admin_audit": "Аудит платформы",
  "admin_kb": "База знаний",
  "admin_reports": "Отчёты администратора",
  "admin_ad_gen": "Генератор рекламы",
  "admin_service_mgr": "Менеджер услуг",
  "admin_tester": "Программа тестировщиков",
  "admin_credits": "Настройка кредитов",
  "admin_account_mgmt": "Управление аккаунтом",
  "admin_payment_opts": "Варианты оплаты",
  "admin_lead_tracking": "Отслеживание лидов",
  "admin_demo": "Демо-доступ",
  "admin_crypto_trading": "Крипто-торговля",
  "admin_auto_posting": "Умная автопубликация",
  "admin_fb": "FB-аналитика",
  "admin_referral_board": "Таблица рефералов",
  "admin_escalations": "Эскалации чатов",
  "admin_portfolio": "Менеджер портфолио",
  "admin_email_templates": "Шаблоны email",
  "admin_social_icons": "Иконки соцсетей",
  "admin_ai_prompts": "Умные промпты",
  "admin_panel": "Панель администратора",
  "admin_sign_out": "Выйти",
  "admin_search_tabs": "Поиск вкладок...",
  "admin_demo_banner": "РЕЖИМ ТОЛЬКО ДЛЯ ЧТЕНИЯ — Демо-аккаунт (Все данные пользователей скрыты)",
  "admin_system_admin": "СИСТЕМНЫЙ АДМИНИСТРАТОР",
  "admin_loading": "Загрузка...",
  "admin_no_matching": "Совпадений не найдено",
  "tester_req_1": "Входите не менее 5 раз в неделю",
  "tester_req_2": "Отправляйте не менее 10 отчётов о багах/отзывов в неделю",
  "tester_req_3": "Тестируйте разные функции, страницы и пользовательские потоки",
  "tester_benefit_1": "Бесплатный доступ к интеллектуальным сервисам (по запросам)",
  "tester_benefit_2": "Панель тестировщика с отслеживанием прогресса",
  "tester_benefit_3": "Приоритетная поддержка от команды",
  "tester_motivation": "Почему вы хотите стать тестировщиком?",
  "tester_motivation_ph": "Расскажите, почему вы хотите помочь тестировать платформу...",
  "tester_experience": "Опыт тестирования (необязательно)",
  "tester_experience_ph": "Любой соответствующий опыт...",
  "tester_dash_desc": "Поддерживайте статус тестировщика, выполняя еженедельные цели.",
  "tester_logins_needed": "ещё входов на этой неделе",
  "tester_reports_needed": "ещё отчётов на этой неделе",
  "tester_report_title_ph": "Заголовок (напр. 'Кнопка не нажимается на мобильном')",
  "tester_report_desc_ph": "Опишите проблему или предложение подробно...",
  "tester_report_page_ph": "URL страницы (необязательно)",
  "seo_page_desc": "Введите URL любого сайта для получения комплексного SEO-анализа с практическими рекомендациями.",
  "seo_page_ph": "Введите URL сайта (напр. example.com)",
  "seo_page_error": "Не удалось проверить сайт. Проверьте URL и попробуйте снова.",
  "profile_bio_ph": "Расскажите о себе...",
  "profile_website_ph": "https://вашсайт.com",
  "profile_interests_ph": "напр. Веб-разработка, Крипто, Технологии",
  "admin_notes_ph": "Добавьте заметку о пользователе...",
  "profile_change_avatar": "Изменить аватар",
  "profile_about": "О вас",
  "profile_interests_hint": "Разделяйте интересы запятыми",
  "privacy_s1_title": "1. Информация, которую мы собираем",
  "privacy_s2_title": "2. Как мы используем вашу информацию",
  "privacy_s3_title": "3. Обмен данными",
  "privacy_s4_title": "4. Безопасность данных",
  "privacy_s5_title": "5. Ваши права",
  "privacy_s6_title": "6. Файлы cookie и отслеживание",
  "privacy_s7_title": "7. Хранение данных",
  "privacy_s8_title": "8. Международные передачи",
  "privacy_s9_title": "9. Изменения в этой политике",
  "privacy_s10_title": "10. Свяжитесь с нами",
  "privacy_intro": "Infinity Business (\"мы\"), управляемый Liber Nostra d.o.o., стремится защитить вашу конфиденциальность.",
  "privacy_last_updated": "Последнее обновление: 7 марта 2026 г.",
  "terms_s1_title": "1. Введение",
  "terms_s2_title": "2. Услуги",
  "terms_s3_title": "3. Учётные записи",
  "terms_s4_title": "4. Платежи и выставление счетов",
  "terms_s5_title": "5. Отказ от ответственности за интеллектуальные услуги",
  "terms_s6_title": "6. Интеллектуальная собственность",
  "terms_s7_title": "7. Конфиденциальность и данные",
  "terms_s8_title": "8. Отказ от ответственности за криптовалюты",
  "terms_s9_title": "9. Ограничение ответственности",
  "terms_s10_title": "10. Изменения",
  "terms_s11_title": "11. Применимое право",
  "terms_s12_title": "12. Контакт",
  "terms_last_updated": "Последнее обновление: февраль 2026",
  "referral_subtitle": "Приглашайте друзей и получайте награды",
  "marketplace_close_preview": "Закрыть предпросмотр",
  "marketplace_live_preview": "Предпросмотр",
  "billing_management": "Управление платежами",
  "billing_manage_desc": "Управляйте способами оплаты, просматривайте счета через портал Stripe.",
  "billing_manage_btn": "Управление платежами",
  "billing_cancel_btn": "Отменить план",
  "change_password_current": "Текущий пароль",
  "change_password_new": "Новый пароль",
  "change_password_confirm": "Подтвердите новый пароль",
  "change_password_btn": "Изменить пароль",
  "change_password_social": "Изменение пароля недоступно для аккаунтов социального входа.",
  "nav_currency": "Валюта",
  "nav_orders": "Мои заказы",
  "plan_features": "Функции вашего плана",
  "project_no_projects": "Пока нет проектов. Проекты появятся здесь после покупки услуги.",
  "onboarding_services_title": "Изучите наши услуги",
  "onboarding_services_subtitle": "Две категории для вас",
  "onboarding_services_content": "Мы предлагаем две категории услуг:",
  "onboarding_services_item1": "B2B: Веб-разработка, мобильные приложения, графический дизайн, хостинг, ПО на заказ, реклама, API",
  "onboarding_services_item2": "P2P: Крипто-образование, DeFi, домены, управляемый трейдинг, цифровые инструменты",
  "onboarding_services_item3": "Умные микро-инструменты: Снимки рынка, анализ конкурентов, генераторы email, планы блога, калькуляторы TAM и др.",
  "onboarding_services_item4": "Обратитесь к RisTA в любое время для персональных расчётов и рекомендаций",
  "onboarding_credits_title": "Система кредитов",
  "onboarding_credits_subtitle": "Предоплаченный баланс для умных сервисов",
  "onboarding_credits_content": "Используйте кредиты для мгновенного доступа к умным сервисам:",
  "onboarding_credits_item1": "1 EUR = 1 кредит. Базовый: 29 кредитов, Премиум: 79, Пожизненный: 499",
  "onboarding_credits_item2": "Бесплатные инструменты доступны без кредитов. Платные микро-инструменты стоят $1 каждый",
  "onboarding_credits_item3": "Скидки за объём: 5% от 50+ EUR, 10% от 100+, 15% от 250+, 20% от 500+",
  "onboarding_credits_item4": "Пополняйте картой, PayPal, myPOS или криптовалютой в панели кредитов",
  "onboarding_chat_title": "Поговорите с RisTA",
  "onboarding_chat_subtitle": "Ваш цифровой партнёр готов",
  "onboarding_chat_content": "RisTA может помочь вам с:",
  "onboarding_chat_item1": "Получение оценок и расчётов проектов",
  "onboarding_chat_item2": "Изучение вариантов услуг подробно",
  "onboarding_chat_item3": "Отправка заявок на услуги",
  "onboarding_chat_item4": "Ответы на вопросы на 11 языках",
  "support_tickets": "Заявки в поддержку",
  "admin_support_tickets": "Заявки в поддержку",
  "admin_auto_translate": "Автоперевод",
  "admin_telegram": "Telegram",
  "admin_ai_prospecting": "ИИ-проспектинг",
  "admin_project_mgmt": "Управление проектами",
  "admin_analytics_widget": "Виджет аналитики",
  "admin_doc_mgmt": "Управление документами",
  "admin_webhooks": "Вебхуки",
  "admin_white_label": "White Label",
  "admin_multi_tenant": "Мультитенант",
  "popular_services": "Популярные услуги",
  "popular_services_desc": "Наиболее востребованные клиентами",
  "purchases": "Покупки",
  "admin_funnel": "Воронка конверсии",
  "admin_wl_licensing": "SaaS-лицензии",
  "admin_analytics_export": "Экспорт аналитики",
  "service_detail_features": "Что включено",
  "service_detail_related": "Связанные услуги",
  "service_detail_back": "Все услуги",
  "checkout_currency": "Валюта оплаты",
  "upsell_title": "Завершите настройку",
  "upsell_desc": "Клиенты, купившие похожее, также добавили:",
  "cart_checkout": "Оформить",
  "cart_empty": "Ваша корзина пуста",
  "push_notifications": "Push-уведомления",
  "push_enabled": "Уведомления включены",
  "push_disabled": "Включить уведомления",
  "blog_ai_generate": "ИИ-генерация",
  "blog_gen_service": "Генерировать для услуги",
  "blog_generating": "Генерация...",
  "export_revenue": "Отчёт о доходах",
  "export_funnel": "Воронка конверсии",
  "export_users": "Список пользователей",
  "export_pdf": "Сводный отчёт",
  "license_generate": "Создать лицензию",
  "license_revoke": "Отозвать",
  "license_renew": "Продлить",
  "license_validate": "Проверить",
  "tier_starter": "Стартовый",
  "tier_professional": "Профессиональный",
  "tier_enterprise": "Корпоративный",
  "blog_subtitle": "Аналитика, обновления и руководства от Infinity Business.",
  "blog_search_placeholder": "Поиск статей...",
  "blog_all": "Все",
  "blog_no_posts": "Публикации не найдены. Загляните позже!",
  "blog_prev": "Назад",
  "blog_next": "Далее",
  "blog_back": "Назад к блогу",
  "micro_tools": "Умные микро-инструменты",
  "micro_tools_title": "Умные микро-инструменты",
  "micro_tools_subtitle": "Бесплатные ИИ микро-инструменты для вашего бизнеса",
  "color_palette_title": "Генератор цветовых палитр",
  "color_palette_desc": "Создавайте красивые палитры для вашего бренда",
  "color_palette_generate": "Создать палитру",
  "color_palette_copy": "Копировать",
  "color_palette_copied": "Скопировано!",
  "color_palette_hex": "HEX",
  "color_palette_rgb": "RGB",
  "color_palette_hsl": "HSL",
  "color_palette_complementary": "Комплементарная",
  "color_palette_analogous": "Аналоговая",
  "color_palette_triadic": "Триадная",
  "color_palette_monochromatic": "Монохромная",
  "admin_menu_overview": "Обзор",
  "admin_menu_users": "Пользователи",
  "admin_menu_blog": "Менеджер блога",
  "admin_menu_analytics": "Аналитика",
  "admin_menu_settings": "Настройки",
  "admin_menu_services": "Услуги",
  "admin_menu_chat": "Чат-сессии",
  "admin_menu_notifications": "Уведомления",
  "admin_menu_support": "Поддержка",
  "admin_menu_security": "Безопасность",
  "admin_menu_backup": "Резервное копирование",
  "admin_menu_revenue": "Доход",
  "admin_menu_funnel": "Воронка",
  "admin_menu_invoicing": "Выставление счетов",
  "admin_menu_projects": "Проекты",
  "admin_menu_email": "Конструктор писем",
  "admin_menu_ai_config": "Настройка ИИ",
  "admin_menu_live_analytics": "Аналитика в реальном времени",
  "admin_menu_platform_audit": "Аудит платформы",
  "docs_title": "Документация",
  "docs_subtitle": "Узнайте, как использовать нашу платформу",
  "try_free_title": "Попробовать бесплатно",
  "try_free_subtitle": "Попробуйте наши услуги бесплатно",
  "subscription_title": "Планы подписки",
  "subscription_subtitle": "Выберите подходящий план",
  "portfolio_title": "Портфолио",
  "portfolio_subtitle": "Наша работа говорит сама за себя",
  "svc_web-dev_label": "Веб-разработка",
  "svc_web-dev_desc": "Сайты, лендинги и веб-приложения",
  "svc_mobile-app_label": "Разработка мобильных приложений",
  "svc_mobile-app_desc": "iOS и Android приложения",
  "svc_graphic-design_label": "Графический дизайн",
  "svc_graphic-design_desc": "Логотипы, брендинг, маркетинговые материалы",
  "svc_custom-software_label": "Индивидуальное ПО",
  "svc_custom-software_desc": "Автоматизация бизнеса и корпоративные инструменты",
  "svc_ai-business-plan_label": "Генератор бизнес-планов",
  "svc_ai-business-plan_desc": "Полный бизнес-план с финансами и анализом рынка",
  "svc_ai-seo-report_label": "Аудит сайта и SEO отчёт",
  "svc_ai-seo-report_desc": "Автоматизированный анализ с рекомендациями",
  "svc_ai-email-campaign_label": "Настройка email-маркетинга",
  "svc_ai-email-campaign_desc": "ИИ пишет тексты и настраивает email-цепочки",
  "svc_ai-competitor-analysis_label": "Отчёт анализа конкурентов",
  "svc_ai-competitor-analysis_desc": "Рыночная разведка и позиционирование",
  "svc_ai-legal-docs_label": "Генератор юридических документов",
  "svc_ai-legal-docs_desc": "NDA, договоры, шаблоны условий",
  "svc_crypto-education_label": "Крипто-образование",
  "svc_crypto-education_desc": "Изучите блокчейн, DeFi и основы крипто",
  "svc_investment-tools_label": "Инвестиционные инструменты",
  "svc_investment-tools_desc": "Отслеживание портфеля и анализ рынка",
  "svc_defi-solutions_label": "DeFi решения",
  "svc_defi-solutions_desc": "Смарт-контракты, фарминг доходности",
  "svc_personal-advertising_label": "Личный бренд",
  "svc_personal-advertising_desc": "Создайте своё присутствие в сети",
  "svc_ai-resume_label": "Умный конструктор резюме",
  "svc_ai-resume_desc": "Резюме, оптимизированные для ATS",
  "svc_ai-brand-kit_label": "Умный логотип и бренд-кит",
  "svc_ai-brand-kit_desc": "Логотип, палитра, типографика и социальные ассеты",
  "svc_ai-social-calendar_label": "Календарь соцсетей и анализ",
  "svc_ai-social-calendar_desc": "30 дней постов с ИИ и стратегией вовлечения",
  "svc_ai-translation_label": "Умный сервис перевода",
  "svc_ai-translation_desc": "Профессиональный перевод на 50+ языков",
  "svc_ai-video-script_label": "Умный сценарист видео",
  "svc_ai-video-script_desc": "Сценарии для YouTube, TikTok и рекламы",
  "admin_grp_dashboard": "Панель",
  "admin_grp_users": "Пользователи и доступ",
  "admin_grp_analytics": "Аналитика и отчёты",
  "admin_grp_services": "Услуги и цены",
  "admin_grp_crypto": "Крипто и DeFi",
  "admin_grp_leads": "Лиды и CRM",
  "admin_grp_content": "Контент",
  "admin_grp_comm": "Коммуникация",
  "admin_grp_social": "Социальные сети",
  "admin_grp_ai": "ИИ и автоматизация",
  "admin_grp_design": "Дизайн и бренд",
  "admin_grp_system": "Система",
  "admin_grp_projects": "Проекты и QA",
  "color_palette_professional": "Профессионально",
  "color_palette_playful": "Игриво",
  "color_palette_luxury": "Люкс",
  "color_palette_nature": "Природа",
  "color_palette_tech": "Технологии",
  "color_palette_warm": "Тёплый",
  "color_palette_cool": "Холодный",
  "blog_translating": "Перевод статьи...",
  "blog_translated_cached": "Переведено",
  "blog_translated_fresh": "Только что переведено",
  "blog_show_original": "Показать оригинал",
  "privacy_s1_content": "Мы собираем информацию, которую вы предоставляете нам напрямую, включая:\n- **Данные аккаунта**: Имя, электронная почта и пароль.\n- **Запросы на услуги**: Детали проекта, бюджет и контактная информация.\n- **Платёжные данные**: Данные обрабатываются через наших партнёров (Stripe, myPOS).\n- **Данные коммуникации**: Сообщения через RisTA, контактные формы и переписка.\n- **Данные об использовании**: Тип браузера, IP-адрес, посещённые страницы.",
  "privacy_s2_content": "Мы используем собранную информацию для:\n- Предоставления, поддержки и улучшения наших услуг\n- Обработки транзакций\n- Отправки технических уведомлений и поддержки\n- Ответов на ваши вопросы\n- Мониторинга и анализа тенденций\n- Обнаружения мошенничества\n- Персонализации вашего опыта с RisTA",
  "privacy_s3_content": "Мы не продаём ваши персональные данные. Мы можем делиться информацией с:\n- **Поставщики услуг**: Компании, выполняющие услуги от нашего имени.\n- **Юридические требования**: Когда это требует закон.\n- **Бизнес-передачи**: В связи со слияниями или продажами.\n- **Согласие**: С вашего явного согласия.",
  "privacy_s4_content": "Мы применяем стандартные меры безопасности:\n- Шифрование данных при передаче (TLS/SSL) и хранении\n- Поддержка двухфакторной аутентификации (2FA)\n- Регулярные аудиты безопасности\n- Контроль доступа и аутентификация\n- Безопасная обработка платежей",
  "privacy_s5_content": "Согласно законодательству о защите данных (включая GDPR), вы имеете право на:\n- **Доступ**: Запросить копию ваших данных\n- **Исправление**: Запросить исправление неточных данных\n- **Удаление**: Запросить удаление данных\n- **Ограничение**: Запросить ограничение обработки\n- **Переносимость**: Запросить перенос в машиночитаемом формате\n- **Возражение**: Возразить против обработки\n- **Отзыв согласия**: Отозвать согласие в любое время\n\nСвяжитесь с нами: privacy@infinitybusiness.org.",
  "privacy_s6_content": "Мы используем основные куки для вашей сессии и настроек. Вы можете управлять куки через браузер.",
  "privacy_s7_content": "Мы храним ваши данные только столько, сколько необходимо для целей их сбора.",
  "privacy_s8_content": "Ваши данные могут быть переданы за пределы ЕЭЗ. Мы обеспечиваем надлежащие гарантии.",
  "privacy_s9_content": "Мы можем обновлять эту политику конфиденциальности. Существенные изменения будут опубликованы на этой странице.",
  "privacy_s10_content": "По вопросам обращайтесь:\n\n**Liber Nostra d.o.o.**\nEmail: privacy@infinitybusiness.org\nСайт: infinitybusiness.org",
  "terms_s1_content": "Добро пожаловать в Infinity Business (\"infinitybusiness.org\"), управляемый **Liber Nostra d.o.o.**. Используя нашу платформу, вы соглашаетесь с настоящими Условиями.",
  "terms_s2_content": "Infinity Business предоставляет цифровые услуги с ИИ:\n- Веб-разработка, мобильные приложения и дизайн (B2B)\n- Корпоративные и рекламные услуги\n- Крипто-образование, инвестиционные инструменты и DeFi (P2P)\n- ИИ-ассистент RisTA\n- Домены и веб-хостинг",
  "terms_s3_content": "Для некоторых функций необходимо создать аккаунт. Вы несёте ответственность за конфиденциальность своих учётных данных.",
  "terms_s4_content": "Услуги могут требовать оплаты. Платежи обрабатываются через третьих лиц (Stripe, PayPal, криптовалюта). Политика возврата:\n- **Разовые услуги**: Невозвратные после оказания.\n- **Подписки**: Можно отменить в любое время.\n- **Индивидуальные проекты**: По индивидуальному соглашению.",
  "terms_s5_content": "Наш ИИ-ассистент \"RisTA\" предоставляет автоматизированные рекомендации. Только в информационных целях.",
  "terms_s6_content": "Весь контент на этой платформе является собственностью Liber Nostra d.o.o.",
  "terms_s7_content": "Использование платформы также регулируется нашей Политикой конфиденциальности.",
  "terms_s8_content": "Криптовалютные услуги предоставляются только в информационных целях. Мы не даём финансовых советов.",
  "terms_s9_content": "Liber Nostra d.o.o. не несёт ответственности за косвенные или последующие убытки.",
  "terms_s10_content": "Мы оставляем за собой право изменять эти Условия в любое время.",
  "terms_s11_content": "Настоящие Условия регулируются законодательством Республики Словения.",
  "terms_s12_content": "По вопросам обращайтесь к нам или пишите на support@infinitybusiness.org.",
  "admin_ad_generator": "Генератор объявлений",
  "admin_add": "Добавить",
  "admin_add_prompt": "Добавить промпт",
  "admin_admin": "Admin",
  "admin_advanced_reporting": "Расширенные отчеты",
  "admin_all": "Все",
  "admin_analytics_dashboard": "Панель аналитики",
  "admin_api_key": "API Key",
  "admin_apply": "Применить",
  "admin_approved": "Одобрено",
  "admin_archive": "Архивировать",
  "admin_are_you_sure": "Вы уверены?",
  "admin_audit_alerts": "Оповещения аудита",
  "admin_author": "Автор",
  "admin_avg_session": "Средняя сессия",
  "admin_back": "Назад",
  "admin_badge": "Значок",
  "admin_balance": "Баланс",
  "admin_banned": "Заблокирован",
  "admin_blog_manager": "Управление блогом",
  "admin_body": "Тело",
  "admin_bounce_rate": "Показатель отказов",
  "admin_browser": "Браузер",
  "admin_campaign": "Кампания",
  "admin_cannot_undo": "Это действие нельзя отменить",
  "admin_category": "Категория",
  "admin_click_rate": "CTR (клики)",
  "admin_close": "Закрыть",
  "admin_completed": "Завершено",
  "admin_configuration": "Конфигурация",
  "admin_confirm": "Подтвердить",
  "admin_contact_info": "Контактная информация",
  "admin_content": "Контент",
  "admin_conversations": "Диалоги",
  "admin_conversion_funnel": "Воронка конверсии",
  "admin_conversion_rate": "Коэффициент конверсии",
  "admin_copied": "Скопировано в буфер обмена",
  "admin_copy": "Копировать",
  "admin_count": "Количество",
  "admin_country": "Страна",
  "admin_create": "Создать",
  "admin_create_experiment": "Создать эксперимент",
  "admin_create_new": "Создать новый",
  "admin_created_success": "Успешно создано",
  "admin_credit_config": "Конфигурация кредитов",
  "admin_critical": "Критический",
  "admin_custom": "Настроить",
  "admin_daily": "Ежедневно",
  "admin_date": "Дата",
  "admin_delete_failed": "Не удалось удалить",
  "admin_deleted_success": "Успешно удалено",
  "admin_demo_access": "Демо-доступ",
  "admin_description": "Описание",
  "admin_deselect_all": "Снять выделение",
  "admin_details": "Детали",
  "admin_device": "Устройство",
  "admin_disable": "Выключить",
  "admin_disabled": "Выключено",
  "admin_doc_viewer": "Просмотр документов",
  "admin_documentation": "Документация",
  "admin_download": "Скачать",
  "admin_draft": "Черновик",
  "admin_duplicate": "Дублировать",
  "admin_email": "Email",
  "admin_enable": "Включить",
  "admin_enabled": "Включено",
  "admin_end_date": "Дата окончания",
  "admin_endpoint": "Endpoint",
  "admin_error": "Ошибка",
  "admin_escalation_queue": "Очередь эскалации",
  "admin_event": "Событие",
  "admin_events": "События",
  "admin_experiment_name": "Название эксперимента",
  "admin_export": "Экспорт",
  "admin_facebook_analytics": "Facebook Analytics",
  "admin_false": "Нет",
  "admin_filter": "Фильтр",
  "admin_frequency": "Частота",
  "admin_generate": "Сгенерировать",
  "admin_headers": "Заголовки",
  "admin_health_monitoring": "Мониторинг состояния",
  "admin_high": "Высокий",
  "admin_high_value_leads": "Ценные лиды",
  "admin_id": "ID",
  "admin_image": "Изображение",
  "admin_import": "Импорт",
  "admin_in_progress": "В процессе",
  "admin_inactive": "Неактивно",
  "admin_inbox": "Входящие Admin",
  "admin_speed_audit": "Аудит скорости",
  "admin_info": "Инфо",
  "admin_ip_address": "IP Address",
  "admin_joined": "Регистрация",
  "admin_knowledge_base": "База знаний",
  "admin_language": "Язык",
  "admin_last_activity": "Последняя активность",
  "admin_last_login": "Последний вход",
  "admin_last_triggered": "Последний запуск",
  "admin_lead_score": "Оценка лида",
  "admin_level": "Уровень",
  "admin_load_failed": "Не удалось загрузить",
  "admin_loading_data": "Загрузка данных...",
  "admin_low": "Низкий",
  "admin_medium": "Средний",
  "admin_messages": "Сообщения",
  "admin_method": "Метод",
  "admin_monetization": "Монетизация",
  "admin_monthly": "Ежемесячно",
  "admin_name": "Имя",
  "admin_next": "Далее",
  "admin_no": "Нет",
  "admin_no_data_available": "Нет данных",
  "admin_no_experiments": "Эксперименты не найдены",
  "admin_no_leads": "Лиды не найдены",
  "admin_no_prompts": "Промпты не найдены",
  "admin_no_results": "Нет результатов",
  "admin_no_results_found": "Результатов не найдено",
  "admin_none": "Нет",
  "admin_off": "Выкл",
  "admin_on": "Вкл",
  "admin_open_rate": "Процент открытий",
  "admin_page_views": "Просмотры страниц",
  "admin_partner_badges": "Значки партнеров",
  "admin_payload": "Payload",
  "admin_payment_options": "Варианты оплаты",
  "admin_platform": "Платформа",
  "admin_platform_audit": "Аудит платформы",
  "admin_points": "Баллы",
  "admin_portfolio_manager": "Управление портфолио",
  "admin_preloader_config": "Preloader Config",
  "admin_preview": "Предпросмотр",
  "admin_previous": "Назад",
  "admin_price": "Цена",
  "admin_priority": "Приоритет",
  "admin_prompt_name": "Название промпта",
  "admin_prompt_text": "Текст промпта",
  "admin_published": "Опубликовано",
  "admin_recipients": "Получатели",
  "admin_referral": "Реферал",
  "admin_referral_leaderboard": "Рейтинг рефералов",
  "admin_refresh": "Обновить",
  "admin_rejected": "Отклонено",
  "admin_remove": "Удалить",
  "admin_reset": "Сбросить",
  "admin_response_time": "Время ответа",
  "admin_restore": "Восстановить",
  "admin_results": "Результаты",
  "admin_retry": "Повторить",
  "admin_revenue_dashboard": "Панель доходов",
  "admin_rista_services": "Сервисы RisTA",
  "admin_role": "Роль",
  "admin_save_changes": "Сохранить изменения",
  "admin_save_failed": "Не удалось сохранить",
  "admin_saved_success": "Успешно сохранено",
  "admin_scheduled": "Запланировано",
  "admin_search": "Поиск",
  "admin_select": "Выбрать",
  "admin_select_all": "Выбрать все",
  "admin_send": "Отправить",
  "admin_sent_success": "Успешно отправлено",
  "admin_server_resources": "Ресурсы сервера",
  "admin_service_manager": "Менеджер сервисов",
  "admin_session_duration": "Длительность сессии",
  "admin_settings": "Настройки",
  "admin_slug": "Slug",
  "admin_social_automation": "SMM автоматизация",
  "admin_something_wrong": "Что-то пошло не так",
  "admin_source": "Источник",
  "admin_start_date": "Дата начала",
  "admin_subject": "Тема",
  "admin_submit": "Отправить",
  "admin_subscribers": "Подписчики",
  "admin_success": "Успех",
  "admin_suspended": "Приостановлен",
  "admin_system_prompt": "System Prompt",
  "admin_tags": "Теги",
  "admin_template": "Шаблон",
  "admin_templates": "Шаблоны",
  "admin_test_results": "Результаты теста",
  "admin_tester_program": "Программа тестирования",
  "admin_title": "Заголовок",
  "admin_total_revenue": "Общий доход",
  "admin_total_sessions": "Всего сессий",
  "admin_total_users": "Всего пользователей",
  "admin_trigger": "Триггер",
  "admin_true": "Да",
  "admin_try_again": "Пожалуйста, попробуйте снова",
  "admin_type": "Тип",
  "admin_unique_visitors": "Уникальные посетители",
  "admin_unsubscribed": "Отписались",
  "admin_unverified": "Не подтвержден",
  "admin_update": "Обновить",
  "admin_updated_success": "Успешно обновлено",
  "admin_upload": "Загрузить",
  "admin_urgent": "Срочный",
  "admin_user": "Пользователь",
  "admin_variant_a": "Вариант A",
  "admin_variant_b": "Вариант B",
  "admin_verified": "Подтвержден",
  "admin_version": "Версия",
  "admin_view": "Просмотр",
  "admin_view_details": "Подробнее",
  "admin_viewer": "Зритель",
  "admin_warning": "Предупреждение",
  "admin_webhook_url": "Webhook URL",
  "admin_weekly": "Еженедельно",
  "admin_yes": "Да",
  "admin_analytics_digestadmin_analytics_digest": "Сводка аналитики",
  "admin_blog_health": "Здоровье блога",
  "credit_title": "Кредиты",
  "credit_subtitle": "Предоплаченный баланс для интеллектуальных сервисов",
  "credit_available_balance": "Доступный баланс",
  "credit_tab_balance": "Баланс",
  "credit_tab_topup": "Пополнить",
  "credit_tab_history": "История",
  "credit_tab_services": "Сервисы",
  "credit_tab_crypto": "Крипто",
  "credit_balance_desc": "Ваш кредит можно использовать для любого ИИ-сервиса:",
  "credit_bulk_discounts": "Оптовые скидки",
  "credit_add_credits": "Добавить кредиты",
  "credit_select_amount": "Выберите сумму или введите значение:",
  "credit_bonus": "бонус",
  "credit_bonus_detail": "Вы получите",
  "credit_total_word": "итого",
  "credit_method_card": "Карта",
  "credit_method_crypto": "Крипто",
  "credit_processing": "Обработка...",
  "credit_add_btn": "Добавить",
  "credit_no_txn": "Транзакций пока нет",
  "credit_txn_topup": "Пополнение",
  "credit_txn_promo": "Промо-кредит",
  "credit_txn_auto": "Авто-покупка",
  "credit_txn_purchase": "Покупка",
  "credit_svc_intelligent": "Интеллектуальный сервис",
  "credit_svc_available": "Доступно",
  "credit_svc_need_more": "Нужно ещё",
  "credit_svc_more": "больше",
  "credit_crypto_send": "Отправить",
  "credit_crypto_amount": "Сумма:",
  "credit_crypto_equivalent": "эквивалент",
  "credit_crypto_network": "Сеть:",
  "credit_crypto_wallet": "Адрес кошелька",
  "credit_crypto_confirm": "Кредиты будут добавлены после подтверждения транзакции.",
  "credit_payment_id": "ID платежа:",
  "credit_crypto_back": "Назад к выбору криптовалюты",
  "credit_crypto_select_title": "Выберите криптовалюту для пополнения",
  "credit_crypto_choose_desc": "Выберите монету. Вы получите адрес кошелька для оплаты.",
  "credit_crypto_select_btn": "Выбрать",
  "credit_minimum": "Минимум €5",
  "credit_redirecting": "Перенаправление...",
  "credit_topup_failed": "Ошибка пополнения",
  "credit_crypto_failed": "Не удалось начать крипто-оплату",
  "cart_title": "Корзина",
  "cart_total": "Итого",
  "cart_stripe_checkout": "Оплата Stripe",
  "cart_credits": "Кредиты",
  "cart_secure_stripe": "Безопасная оплата Stripe",
  "cart_insufficient": "Недостаточно кредитов. Сначала пополните или выберите оплату картой.",
  "cart_pay_card": "Оплатить картой",
  "cart_pay_credits_btn": "Оплатить кредитами",
  "cart_clear": "Очистить корзину",
  "cart_processing": "Обработка...",
  "cart_payment_success": "Оплата прошла успешно! Ваш заказ обрабатывается.",
  "cart_complete_setup": "Завершите настройку",
  "cart_also_added": "Клиенты с похожими покупками также добавили:",
  "cart_add": "Добавить",
  "cart_standard": "Стандарт",
  "cart_remaining_balance": "Остаток баланса:",
  "cart_checkout_failed": "Ошибка оплаты",
  "cart_checkout_no_session": "Не удалось создать сессию оплаты",
  "cart_purchased": "Куплено",
  "cart_services_with_credits": "сервис(ов) за кредиты!",
  "credits_balance_title": "Баланс кредитов",
  "credits_topup_btn": "Пополнить кредиты",
  "credits_rate": "1 EUR = 1 Кредит",
  "credits_total_topup": "Всего пополнено",
  "credits_spent_credits": "Потрачено (Кредиты)",
  "credits_spent_payments": "Потрачено (Платежи)",
  "credits_txn_history": "История транзакций",
  "credits_no_txn": "Транзакций нет",
  "credits_txn_topup": "Пополнение",
  "credits_txn_promo": "Промо-кредит",
  "credits_txn_purchase": "Покупка сервиса",
  "credits_txn_ai": "ИИ-сервис",
  "credits_order_history": "История заказов",
  "credits_order_label": "Заказ:",
  "chat_translate_btn": "Перевести на английский",
  "chat_translating": "Перевод...",
  "chat_translated_label": "Показан английский перевод. Нажмите \"Показать оригинал\" для оригинальных сообщений.",
  "chat_show_original": "Показать оригинал",
  "chat_show_translated": "Показать перевод",
  "pkg_section_badge": "Специальные предложения на ограниченное время",
  "pkg_section_title": "Запустите свой бизнес",
  "pkg_section_title_highlight": "Сегодня",
  "pkg_section_subtitle": "Премиум-пакеты, разработанные для быстрого выхода в онлайн — с интеллектуальной технологией, встроенной с первого дня.",
  "pkg_section_footer": "Все цены указаны без НДС, если это применимо. Не уверены, какой пакет вам подходит? Пообщайтесь с RisTA для бесплатной консультации.",
  "pkg_cta_default": "Начать",
  "admin_package_mgr": "Менеджер пакетов",
  "admin_pkg_title": "Пакеты целевой страницы",
  "admin_pkg_subtitle": "Управление выделенными ценовыми пакетами, отображаемыми на целевой странице",
  "admin_pkg_seed": "Сброс настроек",
  "admin_pkg_new": "Новый пакет",
  "admin_pkg_create_title": "Создать новый пакет",
  "admin_pkg_edit_title": "Редактировать пакет",
  "admin_pkg_name": "Название пакета",
  "admin_pkg_tagline": "Слоган",
  "admin_pkg_description": "Описание",
  "admin_pkg_price": "Цена",
  "admin_pkg_currency": "Валюта",
  "admin_pkg_price_note": "Примечание к цене",
  "admin_pkg_badge": "Значок",
  "admin_pkg_accent": "Цвет акцента",
  "admin_pkg_cta_text": "Текст кнопки CTA",
  "admin_pkg_cta_link": "Ссылка CTA (необязательно)",
  "admin_pkg_sort": "Порядок сортировки",
  "admin_pkg_features": "Включенные характеристики / услуги",
  "admin_pkg_add_feature": "Добавить характеристику",
  "admin_pkg_highlighted": "Выделенный",
  "admin_pkg_normal": "Обычный",
  "admin_pkg_create": "Создать пакет",
  "admin_pkg_save": "Сохранить изменения",
  "admin_pkg_saving": "Сохранение...",
  "admin_pkg_cancel": "Отмена",
  "admin_pkg_empty_title": "Пакеты еще не настроены",
  "admin_pkg_empty_desc": "Нажмите на Сброс настроек, чтобы создать два стартовых пакета, или создайте свой собственный.",
  "admin_pkg_features_label": "характеристики",
  "admin_pkg_sort_label": "Сортировка",
  "admin_pkg_delete_confirm": "Удалить этот пакет? Он будет удалён с целевой страницы.",
  "admin_pkg_feature_placeholder": "Описание характеристики...",
  "admin_pkg_pricenote_placeholder": "например, Одноразово / +5% доля дохода",
  "admin_pkg_badge_placeholder": "например, ЛУЧШАЯ ЦЕНА",
  "admin_pkg_loading": "Загрузка пакетов...",
  "pkg_qa_have_domain": "Да, у меня есть домен",
  "pkg_qa_need_domain": "Мне нужен домен",
  "pkg_qa_describe_biz": "Позвольте описать мой бизнес",
  "pkg_qa_more_info": "Расскажите больше об этом пакете",
  "sp_addon_title": "Дополнения и поддержка",
  "sp_addon_desc": "Усильте свой проект приоритетной поддержкой и экспертными консультациями.",
  "sp_research_title": "Умные исследовательские продукты",
  "sp_research_desc": "Рыночная аналитика по запросу и инструменты умного анализа.",
  "tier_section_badge": "Умные пакеты",
  "tier_section_title": "Выберите свой",
  "tier_section_highlight": "План роста",
  "tier_section_subtitle": "Пакеты, разработанные для максимальной ценности. Выберите подходящий уровень.",
  "tier_one_time": "Разовый платёж",
  "tier_monthly": "Ежемесячно",
  "tier_section_footer": "Все цены указаны без НДС. Нужен индивидуальный пакет? Напишите RisTA.",
  "tier_name_starter": "Стартовый",
  "tier_name_growth": "Рост",
  "tier_name_pro": "Про",
  "tier_name_enterprise": "Корпоративный",
  "tier_tag_starter": "Идеально для начала вашего цифрового присутствия",
  "tier_tag_growth": "Масштабируйте бизнес умными инструментами",
  "tier_tag_pro": "Полноценный цифровой рост для серьёзного бизнеса",
  "tier_tag_enterprise": "Полная цифровая трансформация вашего бизнеса",
  "tier_cta_starter": "Выбрать Стартовый",
  "tier_cta_growth": "Выбрать Рост",
  "tier_cta_pro": "Выбрать Про",
  "tier_cta_enterprise": "Выбрать Корпоративный",
  "tier_badge_popular": "ПОПУЛЯРНЫЙ",
  "tier_badge_best": "ЛУЧШАЯ ЦЕНА",
  "tier_badge_all": "ВСЁ В ОДНОМ",
  "tier_per_mo": "мес.",
  "tier_once_label": "разовый платёж",
  "tier_or_monthly": "или",
  "tier_f_starter_1": "Умный генератор бизнес-плана",
  "tier_f_starter_2": "Умный конструктор резюме (3 шт.)",
  "tier_f_starter_3": "Аудит сайта и SEO-отчёт",
  "tier_f_starter_4": "Умный логотип и бренд-кит",
  "tier_f_starter_5": "Обзор рынка",
  "tier_f_starter_6": "Черновик ответов FAQ",
  "tier_f_starter_7": "Структура блога по тренду",
  "tier_f_starter_8": "Поддержка по email в течение 48ч",
  "tier_f_growth_1": "Всё из Стартового",
  "tier_f_growth_2": "Умная email-кампания",
  "tier_f_growth_3": "Календарь и аналитика соцсетей (3 мес.)",
  "tier_f_growth_4": "Отчёт анализа конкурентов",
  "tier_f_growth_5": "Генератор рекламы (5 кампаний)",
  "tier_f_growth_6": "Генератор email-рассылок",
  "tier_f_growth_7": "Объяснение трендов",
  "tier_f_growth_8": "Анализ позиционирования",
  "tier_f_growth_9": "Приоритетная поддержка email в течение 24ч",
  "tier_f_pro_1": "Всё из Роста",
  "tier_f_pro_2": "Настройка SEO и цифрового маркетинга",
  "tier_f_pro_3": "Настройка email-маркетинга",
  "tier_f_pro_4": "Умный автор видео-сценариев (5 шт.)",
  "tier_f_pro_5": "Быстрый набросок логики TAM",
  "tier_f_pro_6": "Чек-лист рисков",
  "tier_f_pro_7": "Приоритизация функций",
  "tier_f_pro_8": "Черновик списка поставщиков",
  "tier_f_pro_9": "Умная консультация (2 часа)",
  "tier_f_pro_10": "Приоритетная поддержка в течение 12ч",
  "tier_f_ent_1": "Всё из Про",
  "tier_f_ent_2": "Разработка индивидуального ПО",
  "tier_f_ent_3": "Корпоративная рекламная стратегия",
  "tier_f_ent_4": "Управляемый хостинг (12 мес.)",
  "tier_f_ent_5": "План обслуживания (6 мес.)",
  "tier_f_ent_6": "Умная консультация (10 часов)",
  "tier_f_ent_7": "Проверка выхода на рынок",
  "tier_f_ent_8": "Резюме для презентаций",
  "tier_f_ent_9": "Формулировка задачи JTBD",
  "tier_f_ent_10": "Выделенный менеджер",
  "tier_f_ent_11": "Приоритетная очередь (ответ 4ч)",
  "calc_title": "Калькулятор цен",
  "calc_subtitle": "Сравните отдельные услуги с пакетами.",
  "calc_badge": "Экономьте больше",
  "calc_select_services": "Выберите услуги",
  "calc_search_placeholder": "Поиск услуг...",
  "calc_selected": "выбрано",
  "calc_your_selection": "Ваш выбор",
  "calc_individual_total": "Итого по отдельности",
  "calc_best_tier": "Лучший пакет",
  "calc_you_save": "Вы экономите",
  "calc_no_services": "Выберите услуги для расчёта экономии",
  "calc_clear_all": "Очистить всё",
  "calc_get_tier": "Получить этот пакет",
  "calc_individual_cheaper": "Отдельные услуги уже выгодны. Добавьте ещё для экономии!",
  "referred_by": "Приглашение от",
  "referral_signup_reward": "Зарегистрируйтесь, чтобы привязать аккаунт к этой реферальной ссылке.",
  "badge_coming_soon": "Скоро",
  "badge_available_soon": "Скоро будет доступно",
  "badge_from_price": "от",
  "badge_preparing": "Мы готовим эту услугу для вас",
  "svc_managed-hosting_label": "Управляемый хостинг",
  "svc_managed-hosting_desc": "Полностью управляемый хостинг с мониторингом и поддержкой",
  "svc_enterprise-advertising_label": "Корпоративная реклама",
  "svc_enterprise-advertising_desc": "Масштабные рекламные кампании с выделенной стратегией",
  "svc_email-marketing_label": "Настройка email-маркетинга",
  "svc_email-marketing_desc": "Профессиональные email-рассылки, шаблоны и автоматизация",
  "svc_competitor-analysis_label": "Отчёт о конкурентном анализе",
  "svc_competitor-analysis_desc": "Рыночная разведка и конкурентное позиционирование",
  "svc_legal-docs_label": "Генератор правовых документов",
  "svc_legal-docs_desc": "NDA, договоры, шаблоны условий использования",
  "svc_website-audit_label": "Аудит сайта и SEO-отчёт",
  "svc_website-audit_desc": "Комплексный анализ сайта с рекомендациями",
  "svc_trading-consultation_label": "Консультации по трейдингу",
  "svc_trading-consultation_desc": "Экспертные сессии по торговой стратегии",
  "svc_managed-trading_label": "Управляемый трейдинг",
  "svc_managed-trading_desc": "Экспертный трейдинг с проверенными стратегиями",
  "svc_domain-management_label": "Управление доменами",
  "svc_domain-management_desc": "Регистрация доменов, управление DNS и трансферы",
  "svc_personal-branding_label": "Личный бренд",
  "svc_personal-branding_desc": "Создайте своё онлайн-присутствие и личный бренд",
  "admin_escalation_alert": "Эскалация чата",
  "admin_view_escalations": "Очередь эскалаций",
  "from": "От",
  "vector_gen_title": "Умный векторный",
  "vector_gen_title_hl": "генератор",
  "vector_gen_badge": "Умная векторная студия",
  "vector_gen_desc": "Опишите свою идею, загрузите референсы и получите готовую SVG-векторную графику за секунды.",
  "vector_gen_balance": "Ваш баланс",
  "vector_gen_per_gen": "кредитов за генерацию",
  "vector_gen_prompt_label": "Опишите вашу векторную графику",
  "vector_gen_prompt_ph": "напр. Минималистичный логотип горы с солнечными лучами, в бирюзовых и оранжевых тонах...",
  "vector_gen_style": "Стиль",
  "vector_gen_color": "Цветовой режим",
  "vector_gen_refs": "Референсные файлы",
  "vector_gen_optional": "необязательно, макс. 3",
  "vector_gen_upload": "Загрузить референс (PNG, JPG, SVG)",
  "vector_gen_generating": "Генерация...",
  "vector_gen_cta": "Сгенерировать вектор",
  "vector_gen_result": "Ваша векторная графика",
  "vector_gen_model_used": "Модель",
  "vector_gen_history": "История генераций",
  "vector_gen_no_history": "Генераций пока нет",
  "vector_gen_login_req": "Войдите, чтобы использовать векторный генератор.",
  "vector_gen_service_title": "Нужны профессиональные векторы?",
  "vector_gen_service_desc": "Закажите индивидуальную векторную графику как полноценную дизайн-услугу с доработками и руководством по бренду.",
  "vector_gen_service_cta": "Смотреть дизайн-услуги",
  "vector_gen_product_type": "Тип продукта",
  "vector_gen_size": "Размер вывода",
  "vector_gen_error_prompt": "Пожалуйста, опишите вашу идею для векторной графики.",
  "admin_vector_gen": "Векторный генератор",
  "admin_showroom": "Шоурум",
  "admin_landing_page": "Целевая страница",
  "admin_landing_text": "Тексты целевой страницы",
  "admin_vector_title": "Векторный генератор",
  "admin_vector_models": "Доступные модели",
  "admin_vector_pricing": "Цены и лимиты",
  "svc_vector-generator_label": "Умный векторный генератор",
  "svc_vector-generator_desc": "Генерируйте готовую SVG-векторную графику из текстовых описаний",
  "sp_vector_gen_name": "Умный векторный генератор",
  "sp_vector_gen_desc": "Генерируйте SVG-векторную графику из текстовых описаний с помощью умной технологии.",
  "sp_vector_gen_feat": "Генерация текст-в-вектор|Экспорт SVG и PNG|Множество стилей|Встроенный SVG-редактор|Загрузка референсов|Кредитная система",
  "sp_managed_hosting_name": "Управляемый хостинг",
  "sp_managed_hosting_feat": "Мониторинг 24/7|Автообновления|Управление SSL|Ежедневные бэкапы|Оптимизация|Выделенная поддержка",
  "sp_enterprise_ad_name": "Корпоративная реклама",
  "sp_enterprise_ad_feat": "Стратегия кампании|Мультиканал|A/B тесты|Отслеживание|Менеджер|Отчёты",
  "sp_email_marketing_name": "Настройка email-маркетинга",
  "sp_email_marketing_feat": "Email-цепочки|Дизайн шаблонов|Автоматизация|Управление списками|Аналитика|A/B тесты",
  "sp_competitor_analysis_name": "Отчёт анализа конкурентов",
  "sp_competitor_analysis_feat": "Анализ рынка|Профили конкурентов|SWOT|Сравнение цен|Рекомендации|Обновления",
  "sp_website_audit_name": "Аудит сайта и SEO-отчёт",
  "sp_website_audit_feat": "Технический аудит|SEO-анализ|Метрики|Доступность|Сканирование безопасности|План действий",
  "sp_defi_name": "DeFi-решения",
  "sp_defi_feat": "Смарт-контракты|Фарминг доходности|Пулы ликвидности|DeFi аудит|Создание токенов|Стейкинг решения",
  "sp_personal_brand_name": "Личный бренд",
  "sp_personal_brand_feat": "Стратегия бренда|Присутствие в соцсетях|Личный сайт|Планирование контента|Профессиональные фото|Написание био",
  "sp_ad_gen_name": "Генератор рекламы",
  "sp_ad_gen_feat": "Рекламные тексты|Креативные форматы|Мультиплатформа|A/B варианты|Таргетинг аудитории|Советы по эффективности",
  "sp_priority_name": "Приоритетная очередь",
  "sp_priority_feat": "Ответ за 4 часа|Выделенный канал|Приоритетная обработка|Обновления статуса|Гарантия SLA|Расширенная поддержка",
  "sp_maintenance_name": "План обслуживания",
  "sp_maintenance_feat": "Ежемесячные обновления|Патчи безопасности|Мониторинг производительности|Исправление ошибок|Гарантия доступности|Приоритетная поддержка",
  "sp_consulting_name": "Умная консультационная сессия",
  "sp_consulting_feat": "Экспертная консультация|Стратегическая сессия|Технические советы|План внедрения|Записи по итогам|Запись предоставляется",
  "sp_market_snapshot_name": "Обзор рынка",
  "sp_market_snapshot_feat": "Обзор рынка|Ключевые тренды|Конкурентная среда|Возможности роста|Факторы риска|Краткое резюме",
  "sp_trend_explainer_name": "Объяснение трендов",
  "sp_trend_explainer_feat": "Анализ трендов|Влияние на отрасль|Оценка возможностей|Временная проекция|Шаги действий|Визуальный отчёт",
  "sp_competitor_qa_name": "Вопросы о конкурентах",
  "sp_competitor_qa_feat": "Анализ стратегии|Ценовые инсайты|Позиционирование|Сравнение|Анализ слабостей|Карта возможностей",
  "sp_country_entry_name": "Проверка выхода на рынок",
  "sp_country_entry_feat": "Готовность рынка|Регуляторный обзор|Культурные факторы|Конкурентный анализ|Стратегия выхода|Оценка рисков",
  "sp_vendor_shortlist_name": "Шорт-лист поставщиков",
  "sp_vendor_shortlist_feat": "Исследование поставщиков|Сравнительная матрица|Анализ цен|Оценка возможностей|Рекомендации|Контактные данные",
  "sp_tam_logic_name": "Логическая схема TAM",
  "sp_tam_logic_feat": "Оценка TAM|Разбивка SAM/SOM|Логическая модель|Источники данных|Допущения роста|Визуальная презентация",
  "sp_positioning_name": "Стратегия позиционирования",
  "sp_positioning_feat": "Позиционирование|Сегментация аудитории|Ценностное предложение|Фреймворк сообщений|Дифференциация|Конкурентное преимущество",
  "sp_managed_trading_name": "Управляемая торговля",
  "sp_managed_trading_feat": "Управление портфелем|Управление рисками|Проверенные стратегии|Регулярные отчёты|Менеджер|Анализ рынка",
  "sp_trading_consult_name": "Торговые консультации",
  "sp_trading_consult_feat": "Индивидуальные сессии|Разработка стратегии|Анализ рынка|Оценка рисков|Обзор портфеля|Экспертное руководство",
  "sp_domains_name": "Маркетплейс доменов LiveDomain",
  "sp_domains_feat": "Премиум-домены|Вторичный рынок|Оценка доменов|Поддержка трансфера|Переговоры|Управление портфелем",
  "sp_domain_mgmt_name": "Управление доменами",
  "sp_domain_mgmt_feat": "Управление DNS|Автопродление|Поддержка трансфера|Отслеживание портфеля|SSL-сертификаты|Приватность Whois",
  "sp_managed_hosting_desc": "Полностью управляемый хостинг с мониторингом, обновлениями и выделенной поддержкой.",
  "sp_enterprise_ad_desc": "Масштабные рекламные кампании с выделенной стратегией и управлением.",
  "sp_email_marketing_desc": "Профессиональные email-последовательности, шаблоны и автоматизация маркетинга.",
  "sp_competitor_analysis_desc": "Углублённый анализ рынка и конкурентного позиционирования.",
  "sp_website_audit_desc": "Комплексный анализ сайта с практическими рекомендациями.",
  "sp_managed_trading_desc": "Управляемая торговля с проверенными стратегиями и управлением рисками.",
  "sp_trading_consult_desc": "Индивидуальные сессии по торговой стратегии под руководством экспертов.",
  "sp_domains_desc": "Приобретение премиум-доменов и предложения на вторичном рынке.",
  "sp_domain_mgmt_desc": "Управление DNS, продления, трансферы и управление портфелем доменов.",
  "sp_defi_desc": "Смарт-контракты, фарминг доходности и решения для пулов ликвидности.",
  "sp_personal_brand_desc": "Создайте своё онлайн-присутствие и личный бренд.",
  "sp_ad_gen_desc": "Мгновенно создавайте высококонверсионные рекламные тексты и креативы.",
  "sp_priority_desc": "Гарантированный ответ в течение 4 часов.",
  "sp_maintenance_desc": "Постоянное обслуживание, обновления и техническая поддержка.",
  "sp_consulting_desc": "Индивидуальная консультация с нашими экспертами по интеллектуальным технологиям.",
  "sp_market_snapshot_desc": "Быстрый обзор рыночного ландшафта и тенденций.",
  "sp_trend_explainer_desc": "Понимание новых тенденций, релевантных для вашей отрасли.",
  "sp_competitor_qa_desc": "Получите ответы о стратегиях ваших конкурентов.",
  "sp_country_entry_desc": "Оцените готовность рынка к международной экспансии.",
  "sp_vendor_shortlist_desc": "Курируемый список поставщиков для ваших конкретных потребностей.",
  "sp_tam_logic_desc": "Оценка общего целевого рынка с логическим анализом.",
  "sp_positioning_desc": "Анализ позиционирования продукта и аудитории.",
  "vector_gen_model": "Модель",
  "vector_gen_quality": "Уровень качества",
  "svc_smart-resume_label": "Умный конструктор резюме",
  "svc_smart-resume_desc": "Резюме, оптимизированные для ATS, нашей умной системой",
  "svc_smart-business-plan_label": "Умный генератор бизнес-плана",
  "svc_smart-business-plan_desc": "Полный бизнес-план с финансами и анализом рынка",
  "svc_smart-seo-report_label": "Умный SEO-отчёт",
  "svc_smart-seo-report_desc": "Автоматический анализ сайта с практическими рекомендациями",
  "svc_smart-brand-kit_label": "Умный логотип и брендбук",
  "svc_smart-brand-kit_desc": "Концепт логотипа, цветовая палитра, типографика и ресурсы для соцсетей",
  "svc_smart-email-campaign_label": "Умная email-кампания",
  "svc_smart-email-campaign_desc": "Умный email-маркетинг с оптимизированными цепочками",
  "svc_smart-social-calendar_label": "Календарь и анализ соцсетей",
  "svc_smart-social-calendar_desc": "30 дней умных публикаций со стратегией вовлечения",
  "svc_ad-generator_label": "Генератор рекламы",
  "svc_ad-generator_desc": "Мгновенно создавайте высококонверсионные рекламные тексты",
  "svc_smart-translation_label": "Умные услуги перевода",
  "svc_smart-translation_desc": "Профессиональный перевод документов на 50+ языков",
  "svc_smart-video-script_label": "Умный автор видео-сценариев",
  "svc_smart-video-script_desc": "Сценарии для YouTube, TikTok и рекламы, оптимизированные для вовлечения",
  "svc_priority-queue_label": "Приоритетная очередь",
  "svc_priority-queue_desc": "Гарантированный ответ в течение 4 часов",
  "svc_maintenance-plan_label": "План обслуживания",
  "svc_maintenance-plan_desc": "Постоянное обслуживание, обновления и техподдержка",
  "svc_smart-consulting_label": "Умная консультационная сессия",
  "svc_smart-consulting_desc": "Индивидуальная консультация с нашими технологическими экспертами",
  "svc_market-snapshot_label": "Обзор рынка",
  "svc_market-snapshot_desc": "Быстрый обзор рыночного ландшафта",
  "svc_trend-explainer_label": "Объяснение трендов",
  "svc_trend-explainer_desc": "Понимание новых тенденций вашей отрасли",
  "svc_competitor-qa_label": "Вопросы о конкурентах",
  "svc_competitor-qa_desc": "Ответы о стратегиях ваших конкурентов",
  "svc_country-entry-check_label": "Проверка выхода на рынок",
  "svc_country-entry-check_desc": "Оценка готовности рынка к международной экспансии",
  "svc_should-i-care_label": "Проверка релевантности",
  "svc_should-i-care_desc": "Оцените, важен ли тренд для вашего бизнеса",
  "svc_report-matchmaker_label": "Подбор отчётов",
  "svc_report-matchmaker_desc": "Найдите нужный исследовательский отчёт",
  "svc_which-region-first_label": "Приоритет регионов",
  "svc_which-region-first_desc": "Рекомендации по приоритетному выходу на региональный рынок",
  "svc_vendor-shortlist_label": "Шорт-лист поставщиков",
  "svc_vendor-shortlist_desc": "Курируемый список поставщиков",
  "svc_forecast-explanation_label": "Объяснение прогноза",
  "svc_forecast-explanation_desc": "Понятное объяснение рыночных прогнозов",
  "svc_outreach-email-gen_label": "Генератор исходящих писем",
  "svc_outreach-email-gen_desc": "Персонализированные исходящие письма в масштабе",
  "svc_executive-summary_label": "Краткое резюме",
  "svc_executive-summary_desc": "Резюме, готовые для презентаций",
  "svc_faq-answer-draft_label": "Черновик ответов FAQ",
  "svc_faq-answer-draft_desc": "Черновики ответов на часто задаваемые вопросы",
  "svc_jtbd-problem_label": "Формулировка проблемы JTBD",
  "svc_jtbd-problem_desc": "Анализ проблемы по методологии JTBD",
  "svc_tam-logic-sketch_label": "Логическая схема TAM",
  "svc_tam-logic-sketch_desc": "Оценка общего целевого рынка с логическим разбором",
  "svc_risk-checklist_label": "Чек-лист рисков",
  "svc_risk-checklist_desc": "Комплексный чек-лист оценки рисков",
  "svc_feature-prioritization_label": "Приоритизация функций",
  "svc_feature-prioritization_desc": "Рекомендации по приоритизации на основе данных",
  "svc_next-research-question_label": "Следующий исследовательский вопрос",
  "svc_next-research-question_desc": "Откройте следующий важный исследовательский вопрос",
  "svc_positioning-angle_label": "Стратегия позиционирования",
  "svc_positioning-angle_desc": "Анализ позиционирования продукта и аудитории",
  "svc_blog-outline-trend_label": "План блога из тренда",
  "svc_blog-outline-trend_desc": "Превращайте трендовые темы в структурированные планы блогов",
  "admin_ai_reports": "Отчёты AI-сервисов",
  "admin_project_delivery": "0414043e0441044204300432043a0430 043f0440043e0435043a04420430",
  "admin_analytics_digest": "[TRANSLATE] Analytics Digest",
  "admin_seo_suggestions": "[TRANSLATE] SEO Optimization",
  "admin_visitor_map": "[TRANSLATE] Visitor Map",
  "admin_competitor_monitor": "[TRANSLATE] Competitor Intelligence",
  "admin_email_workflows": "[TRANSLATE] Email Workflows",
  "admin_collab_editing": "[TRANSLATE] Team Collaboration",
  "admin_status_online": "[TRANSLATE] Online",
  "admin_status_offline": "[TRANSLATE] Offline",
  "admin_status_online_desc": "[TRANSLATE] You are visible as online. Users requesting escalation will be connected to you.",
  "admin_status_offline_desc": "[TRANSLATE] You are offline. Users requesting escalation will see a message to try later.",
  "admin_ai_model": "[TRANSLATE] AI Model",
  "admin_prompts": "[TRANSLATE] Prompts",
  "admin_no_escalations": "[TRANSLATE] No escalations in queue.",
  "blog_edit": "[TRANSLATE] Edit Post",
  "admin_card_visibility": "[TRANSLATE] Card Visibility",
  "sp_managed_hosting": "[TRANSLATE] Managed Hosting",
  "sp_enterprise_ad": "[TRANSLATE] Enterprise Advertising",
  "sp_email_marketing": "[TRANSLATE] Email Marketing Setup",
  "sp_competitor_analysis": "[TRANSLATE] Competitor Analysis Report",
  "sp_website_audit": "[TRANSLATE] Website Audit & SEO Report",
  "sp_managed_trading": "[TRANSLATE] Managed Trading",
  "sp_trading_consult": "[TRANSLATE] Trading Consultations",
  "sp_domains": "[TRANSLATE] LiveDomain Aftermarket",
  "sp_domain_mgmt": "[TRANSLATE] Domain Management",
  "sp_defi": "[TRANSLATE] DeFi Solutions",
  "sp_personal_brand": "[TRANSLATE] Personal Branding",
  "sp_ad_gen": "[TRANSLATE] Ad Generator",
  "sp_priority": "[TRANSLATE] Priority Queue",
  "sp_maintenance": "[TRANSLATE] Maintenance Plan",
  "sp_consulting": "[TRANSLATE] Smart Consulting Session",
  "sp_market_snapshot": "[TRANSLATE] Market Snapshot",
  "sp_trend_explainer": "[TRANSLATE] Trend Explainer",
  "sp_competitor_qa": "[TRANSLATE] Competitor Q&A",
  "sp_country_entry": "[TRANSLATE] Country Entry Check",
  "sp_vendor_shortlist": "[TRANSLATE] Vendor Shortlist Draft",
  "sp_tam_logic": "[TRANSLATE] Quick TAM Logic Sketch",
  "sp_positioning": "[TRANSLATE] Positioning Angle",
  "agency_rista_tooltip": "Чат с RisTA",
  "agency_hero_title_1": "Молниеносные сайты, которые ",
  "agency_hero_title_highlight": "продают",
  "agency_hero_title_2": " для местного бизнеса",
  "agency_hero_subtitle_1": "Получите персональный сайт, загружающийся за миллисекунды + встроенная аналитика за",
  "agency_hero_subtitle_2": ". Без медленных страниц, больше лидов — запуск за недели.",
  "agency_hero_limited": "Ограниченные места!",
  "agency_hero_cta_pricing": "Пакет за €498",
  "agency_hero_cta_audit": "Бесплатный аудит",
  "agency_trust_maintenance": "обслуживание после",
  "agency_trust_efficient": "100% Эффективно",
  "agency_trust_powered": "На базе Интеллектуальной Системы",
  "agency_speed_title": "Скорость загрузки сайта",
  "agency_speed_before": "До",
  "agency_speed_after": "После",
  "agency_speed_leads": "+35% лидов",
  "agency_pain_title_1": "Медленные сайты ",
  "agency_pain_title_2": "убивают продажи",
  "agency_pain_subtitle": "Каждая секунда загрузки вашего сайта — потерянные клиенты. Вот проблема — и как мы её решаем.",
  "agency_pain_slow_title": "Медленная загрузка = Потерянные лиды",
  "agency_pain_slow_desc": "Ваш сайт загружается более 5 секунд. Посетители уходят, не увидев ваше предложение.",
  "agency_pain_stats_title": "47% уходят при >3с",
  "agency_pain_stats_desc": "Исследование Google показывает, что почти половина посетителей покидает мобильный сайт, который загружается дольше 3 секунд.",
  "agency_pain_stats_source": "Источник: Google/SOASTA Research, 2017",
  "agency_pain_solution_title": "Наша технология Speed-First",
  "agency_pain_solution_desc": "Индивидуальные сайты, оптимизированные для загрузки менее 1 секунды. Edge-кэш, оптимизация изображений, минимизация кода.",
  "agency_pricing_title": "Простые и прозрачные цены",
  "agency_pricing_subtitle": "Выберите план, подходящий вашему бизнесу. Все планы включают нашу технологию Speed-First.",
  "agency_pricing_urgency_1": "Осталось только ",
  "agency_pricing_urgency_2": " стартовых мест в этом месяце",
  "agency_pricing_popular": "САМЫЙ ПОПУЛЯРНЫЙ",
  "agency_pricing_get_started": "Начать",
  "agency_pricing_guarantee": "Гарантия возврата 30 дней",
  "agency_pricing_ideal": "Идеально для:",
  "agency_pricing_starter": "Starter",
  "agency_pricing_onetime": "разовый платёж",
  "agency_pricing_starter_ideal": "Индивидуальных предпринимателей",
  "agency_pricing_s_1": "Молниеносный индивидуальный сайт",
  "agency_pricing_s_2": "Домен + хостинг на 1 год",
  "agency_pricing_s_3": "Базовая панель аналитики",
  "agency_pricing_s_4": "Мобильный адаптивный дизайн",
  "agency_pricing_s_5": "SSL-сертификат включён",
  "agency_pricing_performance": "Performance",
  "agency_pricing_perf_ideal": "Растущие магазины",
  "agency_pricing_p_1": "Всё из Starter",
  "agency_pricing_p_2": "Электронная коммерция + возврат корзины",
  "agency_pricing_p_3": "Пакет SEO-оптимизации",
  "agency_pricing_p_4": "Интеграция A/B тестов",
  "agency_pricing_p_5": "Приоритетная поддержка",
  "agency_pricing_premium": "Premium",
  "agency_pricing_prem_ideal": "Масштабируемый бизнес",
  "agency_pricing_pr_1": "Всё из Performance",
  "agency_pricing_pr_2": "Управление Google Ads",
  "agency_pricing_pr_3": "Еженедельные аудиты производительности",
  "agency_pricing_pr_4": "Персональный менеджер",
  "agency_pricing_pr_5": "Индивидуальные интеграции",
  "agency_social_title": "Доверие местного бизнеса",
  "agency_social_rista_label": "RisTA AI:",
  "agency_social_rista_quote": "Я анализирую поведение посетителей в реальном времени для увеличения ваших конверсий.",
  "agency_social_see_clients": "Что говорят наши клиенты",
  "agency_social_t1_name": "Марко К.",
  "agency_social_t1_role": "CEO, Местный магазин",
  "agency_social_t1_text": "Мы удвоили лиды в первый месяц! Сайт загружается мгновенно, и клиентам нравится новый дизайн.",
  "agency_social_t2_name": "Елена В.",
  "agency_social_t2_role": "Владелица ресторана",
  "agency_social_t2_text": "Наши онлайн-заказы выросли на 40% после запуска. Разница в скорости — как день и ночь.",
  "agency_social_t3_name": "Томас Х.",
  "agency_social_t3_role": "Фитнес-студия",
  "agency_social_t3_text": "Профессионально, быстро и действительно выполняют обещания. Наша конверсия бронирований выросла на 35% за 3 недели.",
  "agency_social_t4_name": "Ана С.",
  "agency_social_t4_role": "Владелица бутика",
  "agency_social_t4_text": "Настройка электронной коммерции прошла безупречно. Только возврат корзин окупил план Performance в первом квартале.",
  "agency_social_metric_1": "Среднее время загрузки",
  "agency_social_metric_2": "Больше лидов",
  "agency_social_metric_3": "Удовлетворённость клиентов",
  "agency_services_title": "Всё, что нужно вашему бизнесу",
  "agency_services_subtitle": "Комплексные цифровые решения для развития вашего присутствия в интернете.",
  "agency_svc_fast_title": "Быстрые сайты",
  "agency_svc_fast_desc": "Индивидуальные сайты с загрузкой менее 1 секунды. Mobile-first, SEO-оптимизация.",
  "agency_svc_ecom_title": "Интернет-магазины",
  "agency_svc_ecom_desc": "Продавайте онлайн с возвратом корзины, обработкой платежей и управлением запасами.",
  "agency_svc_seo_title": "SEO аудит и оптимизация",
  "agency_svc_seo_desc": "Поднимитесь выше в Google. Технический SEO, стратегия контента и ежемесячные отчёты.",
  "agency_svc_ads_title": "Настройка Google Ads",
  "agency_svc_ads_desc": "Быстро получите целевой трафик. Настройка кампаний, оптимизация и отслеживание ROI.",
  "agency_svc_maint_title": "Обслуживание и поддержка",
  "agency_svc_maint_desc": "Хостинг, обновления безопасности, резервные копии и изменения контента. От €30/мес.",
  "agency_faq_title": "Часто задаваемые вопросы",
  "agency_faq_q1": "Как быстро будет загружаться мой сайт?",
  "agency_faq_a1": "Менее 1 секунды. Мы оптимизируем каждую миллисекунду — от ответа сервера до полного визуального отображения.",
  "agency_faq_q2": "Что включено в пакет Starter за €498?",
  "agency_faq_a2": "Молниеносный индивидуальный сайт, домен и хостинг на 1 год, панель аналитики, адаптивный дизайн и SSL-сертификат.",
  "agency_faq_q3": "Сколько времени занимает запуск?",
  "agency_faq_a3": "Большинство проектов Starter запускаются за 2-3 недели. Планы Performance и Premium обычно занимают 4-6 недель.",
  "agency_faq_q4": "Вы предлагаете постоянное обслуживание?",
  "agency_faq_a4": "Да. После первого года обслуживание начинается от €30/мес., включая хостинг, обновления безопасности и незначительные изменения.",
  "agency_faq_q5": "Могу ли я обновить план позже?",
  "agency_faq_a5": "Конечно. Вы можете перейти со Starter на Performance или Premium в любое время. Мы зачтём ваши первоначальные инвестиции.",
  "agency_cta_title_1": "Готовы масштабироваться ",
  "agency_cta_title_2": "без ограничений?",
  "agency_cta_subtitle": "Расскажите о своём бизнесе, и мы создадим индивидуальный план. Бесплатная консультация, без обязательств.",
  "agency_contact_name": "Ваше имя",
  "agency_contact_email": "Email адрес",
  "agency_contact_biz_select": "Выберите тип бизнеса",
  "agency_contact_biz_restaurant": "Ресторан / Еда",
  "agency_contact_biz_retail": "Розничная торговля",
  "agency_contact_biz_services": "Профессиональные услуги",
  "agency_contact_biz_fitness": "Фитнес / Велнес",
  "agency_contact_biz_realestate": "Недвижимость",
  "agency_contact_biz_other": "Другое",
  "agency_contact_submit": "Бесплатная консультация",
  "agency_contact_sent_title": "Сообщение отправлено!",
  "agency_contact_sent_desc": "Мы ответим в течение 24 часов.",
  "agency_exit_title": "Подождите! Бесплатный аудит скорости?",
  "agency_exit_desc": "Узнайте, насколько быстрее мог бы быть ваш сайт. Подробный отчёт — 100% бесплатно.",
  "agency_exit_email": "Ваш email",
  "agency_exit_submit": "Отправить аудит",
  "agency_exit_thanks_title": "Спасибо!",
  "agency_exit_thanks_desc": "Мы отправим бесплатный аудит скорости в течение 24 часов.",
  "agency_footer_brand_desc": "Разработано, размещено и спроектировано Infinitybusiness.org",
  "agency_footer_services": "Услуги",
  "agency_footer_fast_web": "Быстрые сайты",
  "agency_footer_ecom": "Интернет-магазины",
  "agency_footer_seo": "SEO аудит",
  "agency_footer_ads": "Настройка Google Ads",
  "agency_footer_maint": "Обслуживание",
  "agency_footer_company": "Компания",
  "agency_footer_about": "О нас",
  "agency_footer_contact": "Контакты",
  "agency_footer_privacy": "Политика конфиденциальности",
  "agency_footer_terms": "Условия использования",
  "agency_footer_touch": "Свяжитесь с нами",
  "agency_footer_copyright": "© 2026 Infinity Business. Все права защищены.",
  "agency_footer_dev_by": "Разработано, размещено и спроектировано",
  "agency_footer_newsletter": "Подписка на рассылку",
  "agency_footer_subscribe": "Подписаться",
  "agency_sticky_pricing": "Смотреть цены",
  "showroom_page_title": "Шоурум",
  "showroom_meta_desc": "Исследуйте наше портфолио веб-трансформаций. Сравнения до и после реальных клиентских проектов.",
  "showroom_badge": "Наши Работы",
  "showroom_title_prefix": "Проектный",
  "showroom_title_highlight": "Шоурум",
  "showroom_subtitle": "Посмотрите реальные трансформации. Перетащите ползунок для сравнения состояний до и после наших клиентских проектов.",
  "showroom_search_placeholder": "Поиск проектов...",
  "showroom_all_services": "Все Услуги",
  "showroom_sort_newest": "Сначала новые",
  "showroom_sort_oldest": "Сначала старые",
  "showroom_sort_name_az": "Название А-Я",
  "showroom_sort_name_za": "Название Я-А",
  "showroom_active_filters": "Активные фильтры",
  "showroom_showing": "Показано",
  "showroom_project_singular": "проект",
  "showroom_project_plural": "проектов",
  "showroom_empty": "В шоуруме пока нет проектов.",
  "showroom_no_match": "Нет проектов, соответствующих вашим фильтрам.",
  "showroom_features_built": "Реализованные Функции",
  "showroom_visit_live": "Посетить Сайт"
};
